// NEW CODE DELETE INCLUDE
import React, { useState, useEffect, useRef, createContext, useContext, forwardRef, useMemo } from "react";
// import Select from 'react-select';
//import ReportPdf from "../images/report1.pdf";
import Select from "react-select";
import { ReactComponent as Happyicon } from "../images/IconGreen.svg";
import { ReactComponent as Sadicon } from "../images/IconRed.svg";
import { ReactComponent as Doubticon } from "../images/IconOrange.svg";
import Logo from "../images/logo.svg";
import Sidebar from "../component/Sidebar";
import IconSlide from "../images/btn-slide.svg";
import { useStopwatch } from "react-timer-hook";
import IconPlay from "../images/icon-play.svg";
import IconPause from "../images/icon-pause.svg";
import IconArrowDownToggle from "../images/IconArrowDownToggle.svg";
import IconArrowUpToggle from "../images/IconArrowUpToggle.svg";
//AAA
import arrowScore from "../images/arrowScore.svg";

import CreatableSelect from "react-select/creatable";
import { components } from 'react-select';

import { motion, AnimatePresence } from 'framer-motion';
import ReactApexChart from 'react-apexcharts';
import { DatePicker, Tabs, SelectPicker, Whisper, Tooltip, Modal, Button, useToaster, Message, Popover, Placeholder, Loader, Toggle, Uploader, Progress } from "rsuite";
// import DatePicker from "rsuite/DatePicker";
import "rsuite/DatePicker/styles/index.css";
import "rsuite/Tabs/styles/index.css";
import "rsuite/SelectPicker/styles/index.css";
import CurrencySelect from "react-select-currency";
import sampledata1 from "../sample/sample.json";
//import pdfjsLib from 'pdfjs-dist';
import YearPicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useParams, useNavigate, Link } from "react-router-dom";
import { auto } from "@popperjs/core";
import CryptoJS from "crypto-js";
import { FaLessThanEqual } from "react-icons/fa";
// import { set } from "rsuite/esm/utils/dateUtils";
import complianceJson from "../sample/complianceJsonExport.json";
import { FaListCheck } from "react-icons/fa6";
import IconNoData from "../images/IconNoData.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";
import zIndex from "@mui/material/styles/zIndex";
//import Scrollbar from 'smooth-scrollbar';

import LoaderFull from "../component/Loader";
import IconNoComment from "../images/noComment.svg";
import iconWhiteCaret from "../images/iconWhiteCaret.svg";
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';


import LoaderChecking from "../images/IconLoader.svg";
import LoaderChecked from "../images/IconsCheckSaving.svg";
import LoaderCross from "../images/IconCrossSaving.svg";

import iconGreenCls from "../images/IconCalculatorGreen.svg";
import iconBlueCls from "../images/IconCalculatorBlue.svg";


import iconUpload from "../images/iconUpload.svg";
import iconJPG from '../images/iconJPG.svg';
import iconPNG from '../images/iconPNG.svg';
import iconPDF from '../images/iconPDF.svg';
import iconCancel from '../images/iconCancel.svg';

import IconDownloadFile from "../images/IconDownloadFile.svg";
import IconPDFFile from "../images/IconPdfFile.svg";

import icon_jpeg_png from "../images/icon_jpeg_png.svg";
import icons_Docs from "../images/icons_Docs.svg";
import Icons_excel from "../images/Icons_excel.svg";


import 'rsuite/dist/rsuite.min.css';
import moment from 'moment-timezone';

import customCarretArrow from "../images/caret-arrow.svg";
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'

import iconFlagDoughtful from "../images/icon-flag-doughtful.svg";
import iconFlagHalal from "../images/icon-flag-halal.svg";
import iconFlagNotHalal from "../images/icon-flag-not-halal.svg";
import iconCaustomCaretArrow from "../images/custom-caret-arrow.svg";
import IconInfoNew from "../images/iconInfoNew.svg";
import IconBtnPDF from "../images/iconBtnPDF.svg";
import iconUnhideReport from "../images/iconUnhide.svg";
import iconHideReport from "../images/iconHide.svg";



// Create the TimerContext
const TimerContext = createContext();

// TimerProvider component
const TimerProvider = ({ children }) => {
    const [startTime, setStartTime] = useState(null);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [timerRunning, setTimerRunning] = useState(true);

    useEffect(() => {
        let timerInterval;
        if (timerRunning && startTime !== null) {
            timerInterval = setInterval(() => {
                const currentTime = Date.now();
                const elapsed = currentTime - startTime;
                setElapsedTime(elapsed);
            }, 1000);
        }
        return () => clearInterval(timerInterval);
    }, [timerRunning, startTime]);

    return (
        <TimerContext.Provider
            value={{
                startTime,
                setStartTime,
                elapsedTime,
                setElapsedTime,
                timerRunning,
                setTimerRunning,
            }}
        >
            {children}
        </TimerContext.Provider>
    );
};

// useTimer hook to access the TimerContext
const useTimer = () => useContext(TimerContext);

// Timer component
const Timer = forwardRef(
    ({ initialHours = 0, initialMinutes = 0, initialSeconds = 0 }, ref) => {
        const {
            startTime,
            setStartTime,
            elapsedTime,
            setElapsedTime,
            timerRunning,
            setTimerRunning,
        } = useTimer();
        const localRef = useRef(null);
        const timerRef = ref || localRef;

        useEffect(() => {
            const initialElapsed =
                (initialHours * 60 * 60 + initialMinutes * 60 + initialSeconds) * 1000;
            setElapsedTime(initialElapsed);
            setStartTime(Date.now() - initialElapsed);
        }, [initialHours, initialMinutes, initialSeconds, setElapsedTime, setStartTime]);

        const toggleTimer = () => {
            if (timerRunning) {
                setTimerRunning(false);
                setStartTime(null);
            } else {
                const currentTime = Date.now();
                if (!startTime) {
                    setStartTime(currentTime - elapsedTime);
                }
                setTimerRunning(true);
            }
        };

        const formatTime = () => {
            const totalSeconds = Math.floor(elapsedTime / 1000);
            const seconds = totalSeconds % 60;
            const minutes = Math.floor((totalSeconds / 60) % 60);
            const hours = Math.floor(totalSeconds / 3600);
            return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
                }:${seconds < 10 ? "0" + seconds : seconds}`;
        };

        return (
            <div className="timer">
                <span ref={timerRef}>{formatTime()}</span>
                <button onClick={toggleTimer} className="btn_timer_control">
                    {timerRunning ? (
                        <img src={IconPause} alt="Pause" />
                    ) : (
                        <img src={IconPlay} alt="Play" />
                    )}
                </button>
            </div>
        );
    }
);

// const Report = () => {
function IRIReportContent() {
    const toast = useToast()
    const toastIdRef = React.useRef()
    const timeZone = 'Asia/Kolkata';
    const apiEndPoint = process.env.REACT_APP_API_ESG_ENDPOINT;
    const [isLoader, setIsLoader] = useState(false);

    const [sequentialProcessReport, setSequentialProcessReport] = useState('Saving');
    const [sequentialProcessComplaince, setSequentialProcessComplaince] = useState('Saving');
    const [sequentialProcessPublish, setSequentialProcessPublish] = useState('Publishing');
    const [sequentialProcessCompare, setSequentialProcessCompare] = useState('Comparing ');

    const [sequenceLoaderTypeReport, setSequenceLoaderTypeReport] = useState(LoaderChecking);
    const [sequenceLoaderTypeComplaince, setSequenceLoaderTypeComplaince] = useState(LoaderChecking);
    const [sequenceLoaderTypePublished, setSequenceLoaderTypePublished] = useState(LoaderChecking);
    const [sequenceLoaderTypeCompare, setSequenceLoaderTypeCompare] = useState(LoaderChecking);

    const [isCheckingReport, setIsCheckingReport] = useState(true);
    const [isCheckingComplaince, setIsCheckingComplaince] = useState(true);
    const [isCheckingPublished, setIsCheckingPublished] = useState(true);
    const [isCheckingCompare, setIsCheckingCompare] = useState(true);

    const [isSequenceVisible, setIsSequenceVisible] = useState(false);


    // Define state variables to store hours, minutes, and seconds
    const [hours1, setHours] = useState("0");
    const [minutes1, setMinutes] = useState("0");
    const [seconds1, setSeconds] = useState("0");

    const [unpublishButtonLoader, setUnpublishButtonLoader] = useState(false);
    const [publishButtonLoader, setPublishButtonLoader] = useState(false);
    const [commentdata, setCommentData] = useState(null);
    const [commentCount, setCommentCount] = useState(0);
    const [commentLoading, setCommentLoading] = useState(false); // State to manage loading state
    const [commentFieldId, setCommentFieldId] = useState(null);
    const [commentFetchTextValue, setCommentFetchTextValue] = useState(null);
    const [deleteFetchTextValue, setDeleteFetchTextValue] = useState(null);

    const [lastcomments, setLastComments] = useState({});
    const lastCommentsRef = useRef({});


    // const [commentMessage, setCommentMessage] = useState('');
    // const [commentSource, setCommentSource] = useState('');

    const [tabName, setTabName] = useState('ISRI Screening Report');
    const [month36Val, setMonth36Val] = useState("");
    const [month24Val, setMonth24Val] = useState("");
    const [isEdit, setIsEdit] = useState(0);

    const [sampledata, setSampledata] = useState([]);
    const [chkCalculation, setChkCalculation] = useState(0);


    const [errorMessage, setErrorMessage] = useState('');
    const [messageType, setMessageType] = useState(null); // success, error, info


    const [errorMessage1, setErrorMessage1] = useState('');
    const [messageType1, setMessageType1] = useState(null); // success, error, info

    const [mcCurrency, setMCCurrency] = useState("");

    const [custom36MC, setCustom36MC] = useState(0);
    const [custom24MC, setCustom24MC] = useState(0);

    const [cbaStatus, setCBAStatus] = useState(true);
    const [cbaComment, setCbaComment] = useState('');
    const cbaCommentRef = useRef(null);



    //calculator 
    const [AnnualReportOpen, setAnnualReportOpen] = useState(false);
    const [QuarterlyReportOpen, setQuarterlyReportOpen] = useState(false);

    const handleAnnualReportOpen = () => setAnnualReportOpen(true);
    const handleAnnualReportClose = () => setAnnualReportOpen(false);

    const handleQuarterlyReportOpen = () => setQuarterlyReportOpen(true);
    const handleQuarterlyReportClose = () => setQuarterlyReportOpen(false);

    const calculatorQuarter = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'].map(
        item => ({ label: item, value: item })
    );

    const isValidURL = (url) => {
        if (url == null || url === '') {
            // null, undefined, or empty string are considered valid (ignored)
            return true;
        }
        return url.startsWith("https://") || url.startsWith("http://");
    };




    const [selectedValue, setSelectedValue] = useState(null); //Dropdown value






    useEffect(() => {
        document.title = tabName;
    }, [tabName]);

    //Compliance Json varibale declare
    const [complianceAccountsReceivable, setComplianceAccountsReceivable] = useState("");
    const [complianceHalalSum, setComplianceHalalSum] = useState("");
    const [complianceNotHalalSum, setComplianceNotHalalSum] = useState("");
    const [complianceDoubtfulSum, setComplianceDoubtfulSum] = useState("");

    //*******************END Compliance Json varibale********* */

    const timerRef = useRef(null);
    const roleName = localStorage.getItem("novaRolename");
    const userName = localStorage.getItem("novaFirstname");
    const [selectedDate, setSelectedDate] = useState(null);
    const [isChecked, setIsChecked] = useState(false);

    const progressStatus = process.env.REACT_APP_TASK_MANAGER_PROGRESS_Status;
    const navigate = useNavigate();
    const { encryptJSON } = useParams();
    const userid = localStorage.getItem("novauserid");
    const Identifier = localStorage.getItem("Identifier");

    const [editData, setEditData] = useState([]);

    const [responseDecodeData, setResponseDecodeData] = useState({});
    const [responseDecodeScreeningJson, setResponseDecodeScreeningJson] = useState({});
    const [taskId, setTaskId] = useState(0);
    const [juniorAnalystId, setJuniorAnalystId] = useState(0);



    const [selectedPeriod, setSelectedPeriod] = useState(0); // State to store the selected period
    const [selectedQuarter, setSelectedQuarter] = useState("");

    // CURRENCY SELECT
    const [selectedCurrency, setSelectedCurrency] = useState("");


    let defCoreAssets = {};
    for (let i = 0; i <= 100; i++) {
        defCoreAssets["bs_rfco_assets_" + i] = 0;
    }
    const [coreRevenueParentCount, setCoreRevenueParentCount] = useState(defCoreAssets);
    // SHOW HIDE TOGGLE 
    const [show, setShow] = useState(false);

    // SCORE RATING 
    const [iriScore, setIRIScore] = useState();
    const [nvSUM, setNVSUM] = useState();
    const [arrowPosition, setArrowPosition] = useState('0%'); // NEW
    const [iriScoreLabel, setIRIScoreLabel] = useState('');
    const [reportId, setReportId] = useState('');


    const [responseReportJson, setResponseReportJson] = useState({});

    //Decode API
    useEffect(() => {
        const fetchData = async () => {
            setIsLoader(true);
            const url = `${apiEndPoint}/decode`;
            const requestData = {
                data: {
                    user_id: userid, // For track which user send this request
                    encoded: encryptJSON
                }
            };

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData)
                });

                if (!response.ok) {
                    throw new Error('Network response Decode was not ok');
                }


                const responseData = await response.json();
                const data = responseData.data; // Flatten the response

                if (data.status === 'success') {

                    setResponseDecodeData(data.data);
                    setTaskId(data.data.task_id); // set task id
                    setJuniorAnalystId(data.data.user_id);
                    setReportLRUrl(data.data.lr_report);
                    setReportARUrl(data.data.ar_report);
                    setReportId(data.data.report_no);
                    setResponseReportJson(data.data.report_json);

                    //setIRIScore(data.data.iri_score);

                    // const position = calculateArrowPosition(data.data.iri_score);
                    // setArrowPosition(position);

                    //setResponseDecodeScreeningJson(data.data.screening_json);

                    //Update Score
                    // const updatedSelected = data.data.screening_json.map((item, idx) => {
                    //     //const value = item.score?.toString() || "0";
                    //     //const matchedOption = Scaledata.find(option => option.value === value);
                    //     const scoreValue = parseFloat(item.score || 0);
                    //     return Scaledata.find(option => parseFloat(option.value) === scoreValue);
                    //     //return matchedOption || null;
                    // });
                    // setSelectedScaledataList(updatedSelected);

                    //Update NV
                    // const updatedNvScoreList = data.data.screening_json.map((item, idx) => {
                    //     const score = item.nv_score || 0;
                    //     return item.nv_score || null;
                    // });

                    // setNvScoreList(updatedNvScoreList);


                    // const scoreValues = data.data.screening_json.map(item => parseFloat(item.score) || 0);
                    // setChartValues(scoreValues);
                    // //Update Graph Values
                    // setState(prevState => ({
                    //     ...prevState,
                    //     series: [{
                    //         ...prevState.series[0],
                    //         data: scoreValues
                    //     }]
                    // }));
                    //END Update Graph Values




                    //=== Call IRICalculation ALL IN ONCE===

                    // const staticValue = 5;
                    // const updatedScores = [];
                    // let finalScore = 0;
                    // data.data.screening_json.forEach((item, index) => {
                    //     const score = parseFloat(item.score) || 0;
                    //     const weightage = parseFloat(item.weightage) || 0;
                    //     const parsedWeight = weightage / 100;
                    //     const iriScore = (score / staticValue) * parsedWeight;

                    //     updatedScores[index] = iriScore.toFixed(3);
                    //     finalScore += parseFloat(iriScore.toFixed(3));
                    // });

                    // setNvScoreList(updatedScores);


                    // Calculate total IRI score
                    //   let total = 0;
                    //   if (Array.isArray(responseDecodeScreeningJson)) {
                    //     responseDecodeScreeningJson.forEach((item, i) => {
                    //       const scoreVal = updatedScores[i] !== undefined
                    //         ? Number(updatedScores[i])
                    //         : Number(item.nv_score || 0);
                    //       total += scoreVal;
                    //     });
                    //   }

                    // setNVSUM(finalScore.toFixed(2))


                    // const adjustedScore = finalScore * 5;
                    // setIRIScore(adjustedScore.toFixed(2));
                    // const position = calculateArrowPosition(adjustedScore);
                    // setArrowPosition(position);

                    //END OF All calculation at once







                    const time = data.data.report_time;

                    if (time) {
                        const [hours, minutes, seconds] = time.split(":").map(Number);

                        // Update state variables with extracted values

                        setHours(hours);
                        setMinutes(minutes);
                        setSeconds(seconds);

                        console.log('DB Timer : ' + minutes + ' My Timer' + seconds);
                        setIsLoader(false);
                    }

                    else {
                        setIsLoader(false);
                        console.log('Time is null, skipping state updates.');
                    }

                }
                else {
                    setIsLoader(false);
                    console.error('Decode API Error : ' + error.message);
                    setErrorMessage('Decode :' + data.message);
                    setMessageType('error');
                    return false;
                }

            } catch (error) {
                // Handle errors here
                // console.error("Decode API Error:", error);
                setIsLoader(false);
                setErrorMessage('DECODE CATCH :' + error.message);
                setMessageType('error');
                return false;
            }
            finally {
                setLoadingLR(false); // Set loading state to false when done loading LR report
                setLoadingAR(false); // Set loading state to false when done loading AR report
            }
        };

        fetchData();
    }, []);






    const [activePopover, setActivePopover] = useState(null); // State to manage which popover is active

    const handlePopoverToggle = (popover) => {
        setActivePopover(activePopover === popover ? null : popover);
    };



    function removeCommas(value) {
        return value.replace(/,/g, '');
    }

    const [isPanelVisible, setIsPanelVisible] = useState(true);
    const standardsThRef = useRef(null);
    const swapSwitchThRef = useRef(null);

    const [convert36Val, setConvert36Val] = useState(0);
    const [convert24Val, setConvert24Val] = useState(0);

    const [calculate36Val, setCalculate36Val] = useState(0);
    const [calculate24Val, setCalculate24Val] = useState(0);

    const [indexNo, setIndexNo] = useState(0);

    // DATEPICKER
    const [date, setDate] = useState(new Date());
    function CustomCaretIcon() {
        return <i className="icon-calendar"></i>;
    }
    // handle onChange event of the dropdown
    const handleChange = (selectedOption) => {

        setSelectedCurrency(selectedOption.target.value);
    };

    const handleChangePercentage = (e) => {
        setIsChecked(e.target.checked);
        let percentage = isChecked ? 5 : 20;
        setSacscPercentage(percentage);
    };




    const toggleMenu = () => {
        setIsActive(!isActive);
    };

    const handleKeyPress = (event) => {
        // Check if Ctrl key and S key are pressed
        if (event.ctrlKey && event.key === "q") {
            // Trigger a click event on the standardsThRef
            standardsThRef.current.click();
        }
    };

    const handleSwitchPress = (event) => {
        // Check if Ctrl key and S key are pressed
        if (event.ctrlKey && event.key === "m") {
            // Trigger a click event on the standardsThRef
            swapSwitchThRef.current.click();
        }
    };

    const handleKeyPressReport = (event) => {
        // Check if Ctrl key and S key are pressed
        if (event.ctrlKey && event.key === "y") {
            // Apply styles to the report element
            const reportElement = document.getElementById("Reportbox1");
            if (reportElement) {
                reportElement.style.position = "fixed";
                reportElement.style.top = 0;
                reportElement.style.left = 0;
                reportElement.style.width = "100%";
                reportElement.style.height = "100%";
                reportElement.style.zIndex = 999;
                reportElement.style.marginTop = 0;
            }
            const reportViewer = document.getElementById("reportViewer");
            if (reportViewer) {
                reportViewer.style.height = "100vh";
            }
        }
    };

    const handleKeyPressScreen = (event) => {
        // Check if Ctrl key and S key are pressed
        if (event.ctrlKey && event.key === "i") {
            // Apply styles to the report element
            const reportElement = document.getElementById("Reportbox2");
            if (reportElement) {
                reportElement.style.position = "fixed";
                reportElement.style.top = 0;
                reportElement.style.left = 0;
                reportElement.style.width = "100%";
                reportElement.style.height = "100%";
                reportElement.style.zIndex = 999;
                reportElement.style.marginTop = 0;
            }
            const ReportScreening = document.getElementById("ReportScreening");
            if (ReportScreening) {
                ReportScreening.style.maxHeight = "100vh";
            }
        }
    };

    const handleKeyPressEsc = (event) => {
        // Check if Ctrl key and Esc key are pressed
        if (event.ctrlKey && event.key === "z") {
            // Remove styles from the report element
            const reportElement = document.getElementById("Reportbox1");
            if (reportElement) {
                reportElement.style.position = "";
                reportElement.style.top = "";
                reportElement.style.left = "";
                reportElement.style.width = "";
                reportElement.style.height = "";
                reportElement.style.zIndex = "";
                reportElement.style.marginTop = "";
            }
            const reportViewer = document.getElementById("reportViewer");
            if (reportViewer) {
                reportViewer.style.height = "";
            }
        }
    };

    const handleKeyPressEscScreen = (event) => {
        // Check if Ctrl key and Esc key are pressed
        if (event.ctrlKey && event.key === "x") {
            // Remove styles from the report element
            const reportElement = document.getElementById("Reportbox2");
            if (reportElement) {
                reportElement.style.position = "";
                reportElement.style.top = "";
                reportElement.style.left = "";
                reportElement.style.width = "";
                reportElement.style.height = "";
                reportElement.style.zIndex = "";
                reportElement.style.marginTop = "";
            }

            const ReportScreening = document.getElementById("ReportScreening");
            if (ReportScreening) {
                ReportScreening.style.maxHeight = "";
            }
        }
    };



    useEffect(() => {
        // Add event listener when component mounts
        window.addEventListener("keydown", handleKeyPress);
        window.addEventListener("keydown", handleSwitchPress);
        window.addEventListener("keydown", handleKeyPressReport);
        window.addEventListener("keydown", handleKeyPressEsc);

        window.addEventListener("keydown", handleKeyPressScreen);
        window.addEventListener("keydown", handleKeyPressEscScreen);

        return () => {
            window.removeEventListener("keydown", handleKeyPress);
            window.removeEventListener("keydown", handleSwitchPress);
            window.removeEventListener("keydown", handleKeyPressReport);
            window.removeEventListener("keydown", handleKeyPressEsc);
            window.removeEventListener("keydown", handleKeyPressScreen);
            window.removeEventListener("keydown", handleKeyPressEscScreen);
        };
    }, [isPanelVisible]);
    // Dependency array includes isPanelVisible to ensure effect runs when its value changes





    const [selectedOption, setSelectedOption] = useState(null);

    //Current liabilities : Interest bearing liabilities

    const [currentLiabilitiesTotalSum, setCurrentLiabilitiesTotalSum] =
        useState(0);

    //Non-current liabilities : Interest bearing liabilities
    const [nonCurrentLiabilitiesTotalSum, setNonCurrentLiabilitiesTotalSum] =
        useState(0);
    const [valIBAssetsTo36MC, setValIBAssetsTo36MC] = useState(0);
    const [valIBDebtTo36MC, setValIBDebtTo36MC] = useState(0);
    const [valIBAssetsTo24MC, setValIBAssetsTo24MC] = useState(0);
    const [valIBAssetsToTA, setValIBAssetsToTA] = useState(0);
    const [valARAndCashToTA, setValARAndCashToTA] = useState(0);
    const [valARAndCashTo36MC, setValARAndCashTo36MC] = useState(0);
    const [valIBDebtToTA, setValIBDebtToTA] = useState(0);

    const [valNoncompliantRevenue, setValNoncompliantRevenue] = useState(0);
    const [valImpermissibleRevenue, setValImpermissibleRevenue] = useState(0);
    const [valDoubtfulRevenue, setValDoubtfulRevenue] = useState(0);

    const [valComplianceStatusAAOIFI, setValComplianceStatusAAOIFI] = useState(0);
    const [valComplianceStatusDJIM, setValComplianceStatusDJIM] = useState(0);
    const [valComplianceStatusSP, setValComplianceStatusSP] = useState(0);
    const [valComplianceStatusFTSE, setValComplianceStatusFTSE] = useState(0);
    const [valComplianceStatusMSCI, setValComplianceStatusMSCI] = useState(0);
    const [valComplianceStatusMSCIMseries, setValComplianceStatusMSCIMseries] =
        useState(0);
    const [valComplianceStatusSACSC, setValComplianceStatusSACSC] = useState(0);
    const [valComplianceStatusISSI, setValComplianceStatusISSI] = useState(0);

    //Dropdown

    const colourStyles = {
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            //      console.log({ data, isDisabled, isFocused, isSelected });
            return {
                ...styles,
                backgroundColor: isFocused ? "#F8F8F8" : "",
                color: "#333333",
                borderBottom: 1,
                borderStyle: "solid",
                borderColor: "#F2F2F2",
                fontSize: 14,
                fontWeight: 500,
            };
        },
    };

    const [isBox1Visible, setIsBox1Visible] = useState(true);

    const toggleBoxes = () => {
        setIsBox1Visible(!isBox1Visible);
    };













    // TABLE TOGGLE

    const [reportLRUrl, setReportLRUrl] = useState("");
    const [reportARUrl, setReportARUrl] = useState("");
    const [activeKey, setActiveKey] = useState("1"); // State to track active tab
    const [isActive, setIsActive] = useState(false);
    const [loadingLR, setLoadingLR] = useState(true); // Loading state for LR report
    const [loadingAR, setLoadingAR] = useState(true); // Loading state for AR report
    const [tempReportLR, setTempReportLR] = useState("");
    const [tempReportAR, setTempReportAR] = useState("");

    const handleReportLRInputChange = (e) => {
        //LR Link Paste
        setReportLRUrl(e.target.value);
        setIsActive(false);
    };

    const handleReportARInputChange = (e) => {
        //AR Link Paste
        setReportARUrl(e.target.value);
        setIsActive(false);
    };

    const [sacscPercentage, setSacscPercentage] = useState(5);


    //const [selectedYear, setSelectedYear] = useState("");
    const [selectedYear, setSelectedYear] = useState(null); // Initialize with current year

    const CustomInput = ({ value, onClick }) => (
        <button className="custom-datepicker-button" onClick={onClick}>
            {value || "Year"}
            <i className="icon-calendar" />
        </button>
    );

    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= currentYear - 100; i--) {
        years.push(i);
    }

    // In your protected route component
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    // Check if isLoggedIn is set to true or not
    if (!isLoggedIn) {
        navigate("/");
    }

    const [tooltip36MC, setTooltip36MC] = useState(0);
    const [tooltip24MC, setTooltip24MC] = useState(0);

    const tooltip = <Tooltip>You Can Swap The Report Using This Button.</Tooltip>;
    const tooltip_36MarketCap = <Tooltip>{tooltip36MC}</Tooltip>;
    const tooltip_24MarketCap = <Tooltip>{tooltip24MC}</Tooltip>;

    //const [activeKey, setActiveKey] = useState("1"); // State to track active tab

    // Handler function to change active tab
    const handleTabChange = (key) => {
        setActiveKey(key);

    };

    // TABLE ACCORDION
    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    //value cleanup 0.00

    useEffect(() => {
        //When an input field gains focus, this handler checks if the value is "0.00" or "0". If it is, it clears the input value.
        const handleFocus = (event) => {
            if (event.target.value === "0.00" || event.target.value === "0") {
                event.target.value = "";
            }
        };
        //When an input field loses focus, this handler checks if the input value is empty. If it is, it sets the value to "0.00".
        const handleBlur = (event) => {
            if (event.target.value === "") {
                event.target.value = "0.00";
            }
        };

        const handleInput = (event) => {
            let value = event.target.value;

            // Remove non-numeric characters except dot, comma, and minus sign (for negative values)
            //const sanitizedValue = value.replace(/[^0-9.,-]/g, '');
            const sanitizedValue = value.replace(/(?!^)-/g, '').replace(/[^0-9.,-]/g, '');
            // Remove existing commas for proper formatting
            const valueWithoutCommas = sanitizedValue.replace(/,/g, '');

            // Format the number with commas
            const parts = valueWithoutCommas.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            // Join the integer and decimal parts (if any)
            const formattedValue = parts.length > 1 ? parts.join('.') : parts[0];

            event.target.value = formattedValue;
        };

        const formatValue = (input) => {
            let value = input.value;
            const sanitizedValue = value.replace(/[^0-9.,-]/g, '');
            const valueWithoutCommas = sanitizedValue.replace(/,/g, '');
            const parts = valueWithoutCommas.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            const formattedValue = parts.length > 1 ? parts.join('.') : parts[0];
            input.value = formattedValue;
        };

        const inputs = document.querySelectorAll(
            ".clsCashItems, .account_receivables, .clsCashItemsRevenue, .non_current_account_receivables, .total_assets, .clsasset"
        );
        inputs.forEach((input) => {
            formatValue(input); // Format the value on page load
            input.addEventListener("focus", handleFocus);
            input.addEventListener("blur", handleBlur);
            input.addEventListener("keydown", handleInput);
            input.addEventListener("keyup", handleInput);
        });


        // Cleanup event listeners on component unmount or when inputs change
        return () => {
            inputs.forEach((input) => {
                input.removeEventListener("focus", handleFocus);
                input.removeEventListener("blur", handleBlur);
                input.removeEventListener("keydown", handleInput);
                input.removeEventListener("keyup", handleInput);
            });
        };
    }, [sampledata]);

    const [cashItems, setCashItems] = useState([]);
    const [otherInterestBearingAssets, setOtherInterestBearingAssets] = useState(
        []
    );

    const [cashItems1, setCashItems1] = useState([]);
    const [otherInterestBearingAssets1, setOtherInterestBearingAssets1] =
        useState([]);

    const [interest_bearing_liabilities, setInterest_bearing_liabilities] =
        useState([]);
    const [interest_bearing_liabilities1, setInterest_bearing_liabilities1] =
        useState([]);

    const [otherIncome, setOtherIncome] = useState([]);














    //Complaince Json
    const [complianceJsonData, setComplianceJsonData] = useState(null);



    // Blank event handler for 'Send to review' button
    const handleSendToReview = async () => {
        try {
            const status = 2;
            const sendtoTaskPage = true;
            const reportSuccess = await UpdateIRIData(status,sendtoTaskPage);
            // If the report submission failed, stop further processing
            console.log('UpdateIRIData API: ' + reportSuccess);
            if (!reportSuccess) {
                return;
            }

        } catch (error) {
            console.error("An error occurred while handling save as draft:", error);
        }
    };






   

    // Blank event handler for 'Save as draft' button
    const handleSaveAsDraft = async () => {
        try {

            

            const status = 1;
            const sendtoTaskPage = true;
            const reportSuccess = await UpdateIRIData(status,sendtoTaskPage);
            // If the report submission failed, stop further processing
            console.log('UpdateIRIData API: ' + reportSuccess);
            if (!reportSuccess) {
                return;
            }





        } catch (error) {
            console.error("An error occurred while handling save as draft:", error);
        }
    };


    const handleResetSequence = async () => {
        setSequenceLoaderTypeReport(LoaderChecking);
        setSequenceLoaderTypeReport(LoaderChecking);
        setSequenceLoaderTypeReport(LoaderChecking);
        setSequenceLoaderTypeReport(LoaderChecking);

    };



    const handlePublish = async () => {

        try {
          

            setPublishButtonLoader(true);
            const timerElement = timerRef.current;
            const timer = timerElement?.innerText || "";

            const response = await fetch(`${apiEndPoint}/publish_report`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    data: {
                        user_id: userid,
                        task_id: taskId,
                        company_symbol: responseDecodeData?.company_symbol,
                        report_no: reportId
                    }
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            if (data && data.data && data.data.status === "success") {
                

                toastIdRef.current = toast({ 
                    description: data.data.message || "Report published successfully", 
                    status: 'success', 
                    duration: 5000, 
                    isClosable: true, 
                    position: 'bottom'
                });
                const cancelButton = document.getElementById(`CancelPublish`);
                if (cancelButton) {
                    cancelButton.click();
                }
                setTimeout(() => navigate("/IRITaskManager"), 4000);
                setPublishButtonLoader(false);
            }
            else {
                setPublishButtonLoader(false);
                const errorMessage = (data && data.data && data.data.message) ? data.data.message : "Failed to publish report";
                toastIdRef.current = toast({ 
                    description: errorMessage || "An error occurred", 
                    status: 'error', 
                    duration: 5000, 
                    isClosable: true, 
                    position: 'bottom'
                });
            }



        } catch (error) {
            setPublishButtonLoader(false);
            console.error("An error occurred while handling publish:", error);
            const errorMessage = error.message || "An unexpected error occurred while publishing the report";
            toastIdRef.current = toast({ description: errorMessage, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        }
        //setIsSequenceVisible(true);


    };


    const handleUnPublish = async () => {

        

        setUnpublishButtonLoader(true);

        const url = `${apiEndPoint}/unpublish_report`;
        const data = {
            data: {
                company_symbol: responseDecodeData?.company_symbol,
                user_id: userid,
                task_id: taskId,
                report_no: reportId
            }
        };


        try {
            const result = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (!result.ok) {
                throw new Error(`HTTP error! status: ${result.status}`);
            }

            const responseData = await result.json();
            const data1 = responseData?.data; // Flatten the response

            if (data1 && data1.status == "success") {

                const cancelButton = document.getElementById(`CancelUnPublish`);
                if (cancelButton) {
                    cancelButton.click();
                }
                toastIdRef.current = toast({ 
                    description: data1.message || "Report unpublished successfully", 
                    status: 'success', 
                    duration: 5000, 
                    isClosable: true, 
                    position: 'bottom'
                });

                setTimeout(() => navigate("/IRITaskManager"), 4000);
                setUnpublishButtonLoader(false);
            }
            else {
                const cancelButton = document.getElementById(`CancelUnPublish`);
                if (cancelButton) {
                    cancelButton.click();
                }
                setUnpublishButtonLoader(false);
                const errorMessage = (data1 && data1.message) ? data1.message : "Failed to unpublish report";
                toastIdRef.current = toast({ 
                    description: errorMessage || "An error occurred", 
                    status: 'error', 
                    duration: 5000, 
                    isClosable: true, 
                    position: 'bottom'
                });
                setTimeout(() => navigate("/IRITaskManager"), 4000);
            }

        } catch (error) {
            const cancelButton = document.getElementById(`CancelUnPublish`);
            if (cancelButton) {
                cancelButton.click();
            }
            setUnpublishButtonLoader(false);
            console.error('Error:', error.message);
            const errorMessage = error.message || "An unexpected error occurred while unpublishing the report";
            toastIdRef.current = toast({ description: errorMessage, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        }
    };

    const handleSave = async () => {
        try {

           

            const status = responseDecodeData.status;
            const sendtoTaskPage = false;
            const reportSuccess = await UpdateIRIData(status,sendtoTaskPage);
            // If the report submission failed, stop further processing
            console.log('UpdateIRIData API: ' + reportSuccess);
            if (!reportSuccess) {
                return;
            }
        } catch (error) {
            console.error("An error occurred while handling save:", error);
            // Handle errors here if needed
        }
    };



    const handleReject = async () => {
        const payload = {
            data: {
                user_id: userid,              // Replace with dynamic userId if needed
                task_id: taskId,               // Replace with actual taskId
                company_symbol: responseDecodeData.company_symbol,     // Replace with actual symbol
                //reject_by: userid,             // Can be same as userId if reject_by means 'who rejected'
                report_no: reportId
            }
        };

        try {
            const response = await fetch(`${apiEndPoint}/reject_report`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            console.log(result);

            if (result.data.status === "success") {
                navigate("/IRITaskManager");
            } else {
                toastIdRef.current = toast({ description: result.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            }
        } catch (error) {
            toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        }
    };



    // const handleReject = async () => {
    //     const status = 1;
    //     const reviewBy = false; // It is false then it will not shown in request
    //     const sendtoTaskPage = true;
    //     const rejectBy = true;
    //     const reportSuccess = await UpdateIRIData(status,reviewBy,sendtoTaskPage,rejectBy);
    //     // If the report submission failed, stop further processing
    //     console.log('UpdateIRIData API: '+ reportSuccess);
    //     if (!reportSuccess) {
    //       return;
    //     }
    // };





    async function UpdateIRIData(status,sendtoTaskPage) {
        if (toastIdRef.current && toast.isActive(toastIdRef.current)) {
            toast.close(toastIdRef.current);
        }

        // Build updated report_json with calculated scores
        const updatedReportJson = {
            ...responseReportJson, // Keep original structure
            total_score: calculatedScores.totalAverageScore ?? 0,
            categories: responseReportJson?.categories?.map(category => ({
                ...category,
                score: calculatedScores.categoryScores[category.category_id] ?? 0,
                subcategories: category.subcategories?.map(subcategory => {
                    // Convert flag string back to number format (halal=1, not-halal=2, doubtful=3, Off/null=0)
                    const currentFlagString = subcategoryFlags[subcategory.subcategory_id] ?? 
                                             (subcategory.flag === 0 ? null : 
                                              subcategory.flag === 1 ? "halal" : 
                                              subcategory.flag === 2 ? "not-halal" : 
                                              subcategory.flag === 3 ? "doubtful" : null);
                    let flagNumber = 0;
                    if (currentFlagString === "halal") flagNumber = 1;
                    else if (currentFlagString === "not-halal") flagNumber = 2;
                    else if (currentFlagString === "doubtful") flagNumber = 3;

                    return {
                        ...subcategory,
                        score: calculatedScores.subcategoryScores[subcategory.subcategory_id] ?? 0,
                        point: parseInt(subcategoryPoints[subcategory.subcategory_id] ?? subcategory.point?.toString() ?? "0", 10),
                        flag: flagNumber,
                        questions: subcategory.questions?.map(question => {
                            // Convert answer string back to number format (yes=1, no=2, null/not answered=0)
                            const currentAnswer = questionAnswers[question.question_id] ?? 
                                                 (question.answer === 1 ? "yes" : question.answer === 2 ? "no" : null);
                            let answerNumber = 0;
                            if (currentAnswer === "yes") answerNumber = 1;
                            else if (currentAnswer === "no") answerNumber = 2;

                            return {
                                ...question,
                                answer: answerNumber
                            };
                        })
                    };
                })
            }))
        };

        const response = await fetch(`${apiEndPoint}/update_task`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                data: {
                    user_id: userid,
                    company_symbol: responseDecodeData.company_symbol,
                    report_no: reportId,
                    status: status,
                    total_score: calculatedScores.totalAverageScore ?? 0,
                    score_classification: responseDecodeData?.score_classification || "Excellent",
                    report_json: updatedReportJson
                }
            })
        });

        const data = await response.json();
        if (data.data.status === "success") {
            toastIdRef.current = toast({ description: data.data.message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
            if (sendtoTaskPage) {
                navigate("/IRITaskManager");
            }
            return true;
        }
        else {
            toastIdRef.current = toast({ description: data.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            return false;
        }
    }



    //Sub Ticker
    const [open1, setOpen1] = useState(false);
    const handleOpen = () => setOpen1(true);
    const handleClose = () => setOpen1(false);

    //Generate Standard Table data
    const [jsonData, setJsonData] = useState(null);


    //Review SubTicker
    const [data, setData] = React.useState([0, 0, 0, 0, 0]);
    //const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);







    const [currency, setCurrency] = useState([]);
    //const [currencyVal, setCurrencyVal] = useState("");



    const handleCurrencyChange = (value) => {
        setSelectedCurrency(value);
    };
    const handleMCCurrencyChange = (value) => {
        setMCCurrency(value);
    };
    const hideMessage = () => {
        setMessageType(null);
    };

    const renderMessage = () => {
        if (messageType) {
            setTimeout(hideMessage, 4000);
        };

        switch (messageType) {
            case 'success':
                return (
                    <Message type="success" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_success'>
                                <div className='icon_error_msg_inner Icon_success_inner'>
                                    <img src={IconCheckError} alt="Success Icon" />
                                    <div className="progress-circle progress_circle_success"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_success_text'>
                                <h5>Success</h5>
                                <p>{errorMessage}</p>
                            </div>
                        </div>
                    </Message>
                );
            case 'error':
                return (
                    <Message type="error" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_error'>
                                <div className='icon_error_msg_inner Icon_error_inner'>
                                    <img src={IconError} alt="Error Icon" />
                                    <div className="progress-circle progress_circle_error"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_error_text'>
                                <h5>Error</h5>
                                <p>{errorMessage}</p>
                            </div>
                        </div>
                    </Message>
                );
            case 'info':
                return (
                    <Message type="info" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_info'>
                                <div className='icon_error_msg_inner Icon_info_inner'>
                                    <img src={IconInfo} alt="Info Icon" />
                                    <div className="progress-circle progress_circle_info"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_info_text'>
                                <h5>Info</h5>
                                <p>No reports found for the selected priority</p>
                            </div>
                        </div>
                    </Message>
                );
            default:
                return null;
        }
    };


    const hideMessage1 = () => {
        setMessageType1(null);
    };

    const renderMessage1 = () => {
        if (messageType1) {
            setTimeout(hideMessage1, 4000);
        };

        switch (messageType1) {
            case 'success':
                return (
                    <Message type="success" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_success'>
                                <div className='icon_error_msg_inner Icon_success_inner'>
                                    <img src={IconCheckError} alt="Success Icon" />
                                    <div className="progress-circle progress_circle_success"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_success_text'>
                                <h5>Success</h5>
                                <p>{errorMessage1}</p>
                            </div>
                        </div>
                    </Message>
                );
            case 'error':
                return (
                    <Message type="error" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_error'>
                                <div className='icon_error_msg_inner Icon_error_inner'>
                                    <img src={IconError} alt="Error Icon" />
                                    <div className="progress-circle progress_circle_error"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_error_text'>
                                <h5>Error</h5>
                                <p>{errorMessage1}</p>
                            </div>
                        </div>
                    </Message>
                );
            case 'info':
                return (
                    <Message type="info" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_info'>
                                <div className='icon_error_msg_inner Icon_info_inner'>
                                    <img src={IconInfo} alt="Info Icon" />
                                    <div className="progress-circle progress_circle_info"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_info_text'>
                                <h5>Info</h5>
                                <p>No reports found for the selected priority</p>
                            </div>
                        </div>
                    </Message>
                );
            default:
                return null;
        }
    };



    const handle10kReport = () => {
        // Your logic here
        console.log('10k report clicked');
        setReportLRUrl(tempReportLR);
        handleTabChange("1");
    };

    const handle10QReport = () => {
        // Your logic here
        console.log('10Q report clicked');
        setReportLRUrl(tempReportAR);
        handleTabChange("1");
    };



    const popupRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsActive(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    //COMMENT MODAL
    const [commentBoxOpen, setCommentBoxOpen] = React.useState(false);

    const handleCommentBoxOpen = async (item) => {

        setCommentLoading(true);

        console.log('Get The userId :' + userid);
        console.log('Get The Task Id :' + taskId);
        console.log('Get The Commentid :' + item.id);

        setCommentFetchTextValue(item.name);


        setCommentBoxOpen(true);

        setCommentFieldId(item.id); // this value is use in add comment section.

        const requestData = {
            data: {
                user_id: userid,  // 54
                task_id: taskId,  // 97
                field_id: item.id, // cas_and_assets
                report_no: reportId
            }
        };


        //console.log(JSON.stringify(requestData));

        try {
            const response = await fetch(`${apiEndPoint}/get_iri_task_comments`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
                setCommentLoading(false);
            }

            const data = await response.json();

            if (data.data.status == 'success') {
                setCommentLoading(false);
                console.log('Count:', data.data.count);
                console.log('comments:', data.data.comments);
                setCommentCount(data.data.count);
                setCommentData(data.data.comments);
            }
            else {
                setCommentLoading(false);
                console.log('Response data:', data);
            }
        } catch (error) {
            setCommentLoading(false);
            console.error('There was a problem with the fetch operation:', error);
        }


    };


    const addComment = async () => {
        const comment = document.getElementById('txtComment').value;
        const source = document.getElementById('txtSource').value;
        const fileInput = document.getElementById('txtFile');
        const file = fileInput.files[0];

        // if (!comment || !source || !file) {
        //     alert("Comment, source, and file are required.");
        //     return;
        // }

        setAddCommentLoader(true);

        const formData = new FormData();
        formData.append('user_id', userid);
        formData.append('task_id', taskId);
        formData.append('material_issue_id', commentFieldId); // assuming this is mapped to `material_issue_id`
        formData.append('comment', comment);
        formData.append('source', source);
        formData.append('file', file);
        formData.append('company_symbol', responseDecodeData.company_symbol); // make sure this variable is defined somewhere
        formData.append('report_no', reportId);

        try {
            const response = await fetch(`${apiEndPoint}/create_iri_comment`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.data?.status === 'success') {
                setAddCommentLoader(false);
                document.getElementById('txtComment').value = '';
                document.getElementById('txtSource').value = '';
                document.getElementById('txtFile').value = '';
                setCommentCount(data.data.count);
                setCommentData(data.data.comments);

                if (data.data.count > 0) {
                    const targetButton = document.querySelector(`button.esg_btn_comment[data-comment='${commentFieldId}']`);
                    if (targetButton) {

                        targetButton.classList.add('icon_comment_active');
                    }
                }
            } else {
                setAddCommentLoader(false);
                setErrorMessage1(data.data?.message || "Failed to add comment.");
                setMessageType1('error');
            }
        } catch (error) {
            setAddCommentLoader(false);
            console.error('Error:', error);
        }
    };




    const deleteComment = async (id) => {


        setCommentBoxOpen(true);

        const requestData = {
            data: {
                user_id: userid,  // 54
                comment_id: id, // 97
                task_id: taskId,
                field_id: commentFieldId,
                company_symbol: responseDecodeData.company_symbol,
                report_no: reportId
            }
        };


        console.log(JSON.stringify(requestData));

        try {
            const response = await fetch(`${apiEndPoint}/delete_iri_comment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            const data = await response.json();
            console.log(JSON.stringify(data));
            if (data.data.status == 'success') {
                console.log('Count:', data.data.count);
                console.log('comments:', data.data.comments);
                setCommentCount(data.data.count);
                setCommentData(data.data.comments);

                if (data.data.count == 0) {
                    // If count is 0, remove the class
                    const targetButton = document.querySelector(`button.esg_btn_comment[data-comment='${commentFieldId}']`);
                    if (targetButton) {
                        targetButton.classList.add('icon_comment_active');
                    }
                    // else{
                    //        targetButton.classList.remove('icon_comment_active')
                    // }
                }
            }
            else {
                toastIdRef.current = toast({ description: data.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                return false;
                setErrorMessage1(data.data.message);
                setMessageType1('error');
                console.log('Response data:', data);
            }
        } catch (error) {

            console.error('There was a problem with the fetch operation:', error.message);
        }


    };

    const deleteWholeRowComment = async (inputCommentId) => {


        const requestData = {
            data: {
                user_id: userid,  // 54
                id: 0, // 97
                task_id: taskId,
                field_id: inputCommentId,
                report_no: reportId,
            }
        };


        console.log(JSON.stringify(requestData));

        try {
            const response = await fetch(`${apiEndPoint}/delete_comment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            const data = await response.json();
            console.log(JSON.stringify(data));
            if (data.data.status == 'success') {

            }
            else {
                setErrorMessage(data.data.message);
                setMessageType('error');
                console.log('Response data:', data);
            }
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error.message);
        }


    };

    const handleCommentBoxClose = () => setCommentBoxOpen(false);

    // FILE UPLOAD
    const [fileName, setFileName] = useState("");
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        setFileName(event.target.files[0].name);
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };
    // END FILE UPLOAD

    const [addCommentLoader, setAddCommentLoader] = useState(false);



    const updateTaskDate = async () => {
        try {
            const response = await fetch(`${apiEndPoint}/update_misri_date`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: {
                        user_id: userid,
                        task_id: taskId,
                        company_symbol: responseDecodeData.company_symbol,
                        report_no: reportId
                    },
                }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            // setResponse(data);
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    };

    useEffect(() => {
        if (userid && taskId) {
            console.log('Call updateTaskDate API : ' + userid + ' : ' + taskId);
            // Call the function immediately
            updateTaskDate();

            // Set up the interval to call the function every 30 seconds (30000 milliseconds)
            const intervalId = setInterval(updateTaskDate, 30000);

            // Clean up the interval on component unmount
            return () => clearInterval(intervalId);
        }
    }, [userid, taskId]);


    const handleBack = () => {
        navigate("/IRITaskManager");
    };

    // COLLAPSIBLE
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };







    const [openReportPopover, setOpenReportPopover] = useState(false);
    const [openPopoverId, setOpenPopoverId] = useState(null);

    const handleDeleteButtonClick = (inputCommentId) => {
        const inputElement = document.querySelector(`input[data-commentval="${inputCommentId}"]`);

        // Check if the element exists and retrieve the defaultValue, otherwise return an empty string
        if (inputElement) {
            //console.log(inputElement.value || '');
            setDeleteFetchTextValue(inputElement.value || '');
        }
        else {
            setDeleteFetchTextValue('');
        }
        setOpenPopoverId((prevId) => (prevId === inputCommentId ? null : inputCommentId));
    };

    const handleCancelClick = () => {
        setOpenPopoverId(null);
    };

    const handleDeleteClick = () => {
        setOpenReportPopover(false);
    };


    let subcommentIndex = 0;


    // const ratings = [
    //     { label: "Poor", color: "#d60000" },
    //     { label: "Weak", color: "#f76c0c" },
    //     { label: "Fair", color: "#f2d54c" },
    //     { label: "Good", color: "#9cc83c" },
    //     { label: "Excellent", color: "#00a21d" },
    // ];
    const ratings = [
        {
            label: "Poor",
            gradient: "linear-gradient(-270deg, #C60201 50%, #E04317 100%)",
        },
        {
            label: "Weak",
            gradient: "linear-gradient(-270deg, #E24819 50%, #EB9F32 100%)",
        },
        {
            label: "Fair",
            gradient: "linear-gradient(-270deg, #ECA433 50%, #BEC835 100%)",
        },
        {
            label: "Good",
            gradient: "linear-gradient(-270deg, #B9C634 50%, #4FA017 100%)",
        },
        {
            label: "Excellent",
            gradient: "linear-gradient(-270deg, #4C9F16 50%, #0A9203 100%)",
        },
    ];


    useEffect(() => {
        if (iriScore !== undefined && iriScore !== null) {
            if (iriScore >= 4 && iriScore <= 5) {
                setIRIScoreLabel('Excellent');
            } else if (iriScore >= 3 && iriScore < 4) {
                setIRIScoreLabel('Good');
            } else if (iriScore >= 2 && iriScore < 3) {
                setIRIScoreLabel('Fair');
            } else if (iriScore >= 1 && iriScore < 2) {
                setIRIScoreLabel('Weak');
            } else if (iriScore >= 0 && iriScore < 1) {
                setIRIScoreLabel('Poor');
            } else {
                setIRIScoreLabel('-'); // If score is outside 0-5
            }
        }
    }, [iriScore]);

    const [chartValues, setChartValues] = useState([0, 0, 0, 0, 0]);
    // RADAR CHART
    const [state, setState] = useState({
        series: [{
            name: 'IRI Score',
            data: chartValues,
        }],
        options: {
            chart: {
                type: 'radar',
                toolbar: { show: false },
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 500
                }
            },
            plotOptions: {
                radar: {
                    size: 120,
                    polygons: {
                        strokeColor: '#e8e8e8',
                        fill: {
                            colors: ['#D7E1F7', '#fff']
                        }
                    }
                }
            },
            xaxis: {
                categories: [
                    'Community',
                    'Rights',
                    'Product',
                    'Env.',
                    'Gov.'
                ],
                labels: {
                    style: {
                        colors: '#344C79',
                        fontSize: '12px',
                        fontWeight: 500
                    }
                }
            },
            yaxis: {
                show: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['#6472C0'],
            },
            fill: {
                opacity: 0.3,
                colors: ['#B1B6D7'],
            },
            markers: {
                size: 6,
                colors: ['#D8D8D8'],              // inner color
                strokeColor: '#D8D8D8',        // border color
                strokeWidth: 0,
                hover: {
                    size: 8
                }
            },
            tooltip: {
                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    const fullLabels = [
                        'Community Impact & Reputation',
                        'Human Rights & Labor Practices',
                        'Product & Sector Involvement',
                        'Environmental Responsibility',
                        'Ethical Governance'
                    ];
                    return `<div style="padding:6px;">
                  <strong>${fullLabels[dataPointIndex]}</strong>: <span style="font-weight:bold">${series[seriesIndex][dataPointIndex]}%</span>
              </div>`;
                }
            }
        }

    });


    // SELECT
    const Scaledata = [
        { label: '0', value: '0' },
        { label: '0.5', value: '0.5' },
        { label: '1', value: '1' },
        { label: '1.5', value: '1.5' },
        { label: '2', value: '2' },
        { label: '2.5', value: '2.5' },
        { label: '3', value: '3' },
        { label: '3.5', value: '3.5' },
        { label: '4', value: '4' },
        { label: '4.5', value: '4.5' },
        { label: '5', value: '5' },
    ];

    const [selectedScaledata, setSelectedScaledata] = useState(null);
    const [selectedScaledataList, setSelectedScaledataList] = useState([]);
    const [nvScoreList, setNvScoreList] = useState([]); // to store calculated scores

    const handleChangeScore = (value, index) => {

        const updatedSelected = [...selectedScaledataList];
        updatedSelected[index] = value;
        console.log(updatedSelected);
        setSelectedScaledataList(updatedSelected);


        // Update chart Values
        const newChartValues = [...chartValues];
        newChartValues[index] = value?.value || 0;

        setChartValues(newChartValues);
        setState(prevState => ({
            ...prevState,
            series: [{
                ...prevState.series[0],
                data: newChartValues
            }]
        }));
        // END Update chart Values


        // Trigger IRICalculation
        const weightage = responseDecodeScreeningJson[index]?.weightage;
        IRICalculation(value?.value, weightage, index);
    };

    const IRICalculation = (selectedValue, weightage, index) => {

        console.log(selectedValue, weightage, index);

        const staticValue = 5;
        const parsedWeight = parseFloat(weightage / 100); // assume weightage is a string like '20'
        const score = (selectedValue / staticValue) * parsedWeight;

        console.log(index + ' : ' + score);

        const updatedNvScores = [...nvScoreList];
        updatedNvScores[index] = score.toFixed(3); // round to 2 decimal places if needed
        setNvScoreList(updatedNvScores);


        // Compute total IRI score = sum of all scores (either updatedNvScores or fallback to item.nv_score)
        let total = 0;


        if (Array.isArray(responseDecodeScreeningJson)) {
            responseDecodeScreeningJson.forEach((item, i) => {
                const scoreVal = updatedNvScores[i] !== undefined
                    ? Number(updatedNvScores[i])  // ensure it's a number
                    : Number(item.nv_score || 0); // fallback and ensure number

                total += scoreVal;  // numeric addition
            });
        }
        setNVSUM(total.toFixed(2));
        const finalScore = (total * 5);

        setIRIScore(finalScore.toFixed(2));

        // NEW: Set arrow position immediately using calculated value

        const position = calculateArrowPosition(finalScore);
        setArrowPosition(position);


    };

    function calculateArrowPosition(finalScore) {
        const normalized = finalScore / 5; // 0 to 1
        const offset = 12 - (normalized * 39); // +15px to -15px (ishare ke hisaab se adjust kar sakte ho)
        const position = `calc(${normalized * 100}% + ${offset}px)`;
        return position;
    }


    const getScoreClass = (value) => {
        const classMap = {
            0: '',
            0.5: '',
            1: 'score_field_color2',
            1.5: 'score_field_color2',
            2: 'score_field_color3',
            2.5: 'score_field_color3',
            3: 'score_field_color1',
            3.5: 'score_field_color1',
            4: 'score_field_color5',
            4.5: 'score_field_color5',
            5: 'score_field_color4',
            5.5: 'score_field_color4',
        };

        return `score_field ${classMap[value] || ''}`;
    };

    const CustomDropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <img
                src={iconCaustomCaretArrow}
                alt="dropdown arrow"
                style={{ width: 11, height: 11 }}
            />
        </components.DropdownIndicator>
    );

    const [uploadedfileList, setUploadedFileList] = useState([]);
    const [progress, setProgress] = useState({});
    const [timeRemaining, setTimeRemaining] = useState({});
    const [preview, setPreview] = useState("");
    const [reportType, setReportType] = useState("");

    const [showUploadManualModal, setUploadManualModal] = useState(false);
    const closeUploadManualModal = () => setUploadManualModal(false);

    const [showUploadpreviewModal, setUploadpreviewModal] = useState(false);
    const closeUploadpreviewModal = () => setUploadpreviewModal(false);


    // Function to handle file selection and upload
    const handleFileSelect = async (file) => {
        if (!file || !file.blobFile) return;

        const newFile = {
            file: file.blobFile,
            name: file.name,
            url: URL.createObjectURL(file.blobFile),
            startTime: Date.now(),
            progress: 0,
            status: "Uploading...", // Initial status
        };

        setUploadedFileList((prevFiles) => [...prevFiles, newFile]); // Append new file to list
        await uploadFile(newFile);
    };

    // Function to upload files to the API
    const uploadFile = async (fileObj) => {

        setProgress((prev) => ({ ...prev, [fileObj.name]: 0 }));

        const formData = new FormData();
        formData.append("task_id", taskId);
        formData.append("files[]", fileObj.file);
        formData.append("report_no", reportId);


        let progressValue = 0;
        const startTime = Date.now();

        // Fake progress update every 500ms
        const interval = setInterval(() => {
            progressValue += Math.random() * 10; // Random increment
            progressValue = Math.min(progressValue, 95); // Max 95% tak jayega

            setProgress((prev) => ({ ...prev, [fileObj.name]: Math.round(progressValue) }));
        }, 500);

        try {
            const response = await fetch(`${apiEndPoint}/upload_iri_task_files`, {
                method: "POST",
                body: formData,
            });

            const result = await response.json();
            console.log(`Upload Success: ${fileObj.name}`, result);

            if (result?.data?.status === "success" && result?.data?.files?.length > 0) {

                const newFiles = result.data.files.map((file) => ({
                    id: file.id,
                    name: file.title,
                    fileKey: file.id,
                    url: file.file_url,
                    type: file.file_type,
                    size: file.file_size,
                }));

                setUploadedFileList(newFiles);
            }
            else if (result?.data?.status === "error") {
                const newFiles = result.data.files.map((file) => ({
                    id: file.id,
                    name: file.title,
                    fileKey: file.id,
                    url: file.file_url,
                    type: file.file_type,
                    size: file.file_size,
                }));
                setUploadedFileList(newFiles);
                setErrorMessage(result?.data?.message);
                setMessageType('error');
            }

            // Once upload completes, set progress to 100%
            setProgress((prev) => ({ ...prev, [fileObj.name]: 100 }));

        } catch (error) {
            console.error(`Upload Failed: ${fileObj.name}`, error);
        } finally {
            clearInterval(interval); // Stop progress updates

        }
    };

    // Function to calculate time remaining based on upload speed
    const updateTimeRemaining = (fileName, uploadedSize, totalSize, startTime) => {
        const elapsedTime = (Date.now() - startTime) / 1000; // in seconds
        const uploadSpeed = uploadedSize / elapsedTime; // bytes per second
        const remainingSize = totalSize - uploadedSize;
        const estimatedTime = uploadSpeed > 0 ? remainingSize / uploadSpeed : 0;

        setTimeRemaining((prev) => ({
            ...prev,
            [fileName]: estimatedTime.toFixed(2),
        }));
    };

    const renderProgress = (file) => {
        return (
            <div key={file.name} style={{ marginTop: 10 }}>
                <p>
                    {file.name} - {file.status}
                </p>
                <div style={{ width: "100%", background: "#ccc", borderRadius: 5 }}>
                    <div
                        style={{
                            width: `${progress[file.name] || 0}%`,
                            background: "#4caf50",
                            height: "10px",
                            borderRadius: 5,
                        }}
                    ></div>
                </div>
                <p>{progress[file.name] || 0}% uploaded</p>
                {file.status === "Uploading..." && (
                    <p>Time Remaining: {timeRemaining[file.name] || "Calculating..."} sec</p>
                )}
            </div>
        );
    };




    const getFileIcon = (fileType) => {
        if (fileType.includes('jpeg') || fileType.includes('jpg')) return iconJPG;
        if (fileType.includes('png')) return iconPNG;
        if (fileType.includes('pdf')) return iconPDF;
        return null;
    };

    const handleRemove = async (file) => {
        console.log('Removed file:', file);

        const url = `${apiEndPoint}/delete_iri_task_file`;

        const requestData = {
            data: {
                user_id: userid,
                file_id: file.fileKey,
                task_id: taskId,
                report_no: reportId

            }
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            });

            const result = await response.json();
            console.log('API Response:', result);

            if (result?.data?.status === 'success') {
                console.log('File deleted successfully:', file.fileKey);

                const newFiles = result.data.files.map((file) => ({
                    id: file.id,
                    name: file.title,
                    fileKey: file.id,
                    url: file.file_url,
                    type: file.file_type,
                    size: file.file_size,
                }));
                setUploadedFileList(newFiles);

            } else {
                console.error('Failed to delete file:', result?.data?.message || 'Unknown error');
            }

            // Agar API success response de to file list se remove karne ka logic yahan likho
        } catch (error) {
            console.error('Error deleting file:', error);
        }
    };



    const handleUploadClick = async () => {
        try {
            const response = await fetch(`${apiEndPoint}/get_iri_task_files`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    data: {
                        user_id: userid,
                        task_id: taskId,
                        report_no: reportId
                    },
                }),
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const result = await response.json();
            console.log('S:' + result?.data?.status);
            if (result?.data?.status === "success" && result?.data?.files?.length > 0) {
                const newFiles = result.data.files.map((file) => ({
                    id: file.id,
                    name: file.title,
                    fileKey: file.id,
                    url: file.file_url,
                    type: file.file_type,
                    size: file.file_size,
                }));
                console.log('AAAAW' + newFiles);

                // setUploadedFileList((prev) => [...prev, ...newFiles]);
                setUploadedFileList(newFiles);

            }
            setUploadManualModal(true);
            //setFiles(result.data); // API response ke `data` ko store kar rahe hain
            console.log("Files:", result);
        } catch (error) {
            console.error("Error fetching task files:", error.message);
        }
    };

    const handlePreviewClick = (file) => {
        setReportType(file.type);
        setPreview(file.url);
        setUploadpreviewModal(true);
    };

    useEffect(() => {
        if (QuarterlyReportOpen) {
            const backdrop = document.querySelector('.rs-modal-open');
            if (backdrop) {
                backdrop.classList.add('custom_backdrop');
            }
        }

        return () => {
            const backdrop = document.querySelector('.rs-modal-backdrop');
            if (backdrop) {
                backdrop.classList.remove('custom_backdrop');
            }
        };
    });

    // RATING DROPDOWN TABLE
    const CustomDropdown = ({ options, value, setValue, customArrow, placeholder }) => {
        const [open, setOpen] = useState(false);
        const dropdownRef = useRef(null);
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setOpen(false);
                }
            };

            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, []);


        return (
            <div className="custom__dropdown" ref={dropdownRef}>
                <div
                    className="custom__dropdown__selected"
                    onClick={() => setOpen(!open)}
                >
                    {value !== undefined && value !== null
                        ? options.find((opt) => opt.value === value)?.label
                        : placeholder}
                    {customArrow && <span className="custom__dropdown__arrow">{customArrow}</span>}
                </div>

                {open && (
                    <ul className="custom__dropdown__list">
                        {options.map((opt) => (
                            <li
                                key={opt.value}
                                className="custom__dropdown__item"
                                onClick={() => {
                                    setValue(opt.value);
                                    setOpen(false);
                                }}
                            >
                                {opt.label}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    };
    const [number, setNumber] = useState("0");
    const [numberOptions] = useState([
        { value: "0", label: "0" },
        { value: "-1", label: "-1" },
        { value: "-2", label: "-2" },
        { value: "-3", label: "-3" },
        { value: "-4", label: "-4" },
        { value: "-5", label: "-5" },
    ]);
    const [numbervalue, setNumbervalue] = useState("100");
    const [numbervalueOptions] = useState([
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },
        { value: "10", label: "10" },
        { value: "20", label: "20" },
        { value: "30", label: "30" },
        { value: "40", label: "40" },
        { value: "50", label: "50" },
        { value: "100", label: "100" },
    ]);
    const [flag, setFlag] = useState("halal");
    const [flagOptions] = useState([
        { value: "Off", label:"Off" },
        { value: "halal", label: <span className="flag halal"><img src={iconFlagHalal} /></span> },
        { value: "not-halal", label: <span className="flag not-halal"><img src={iconFlagNotHalal} /></span> },
        { value: "doubtful", label: <span className="flag doubtful"><img src={iconFlagDoughtful} /></span> },
    ]);

    // YESNO TOGGLE - Track answers for each question by question_id
    const [questionAnswers, setQuestionAnswers] = useState({}); // { question_id: "yes" | "no" | null }

    // TABLE COLLAPSIBLE ACCORDION
    const [openRow, setOpenRow] = useState(null); // Track open category by category_id
    const [openChild, setOpenChild] = useState(null); // Track open subcategory by "categoryId-subcategoryId"

    const toggleAccordion = (rowId) => {
        setOpenRow(openRow === rowId ? null : rowId);
        setOpenChild(null); // parent change hote hi child close ho jaye
    };

    const toggleChild = (childId) => {
        setOpenChild(openChild === childId ? null : childId);
    };

    // Track point and flag for each subcategory
    const [subcategoryPoints, setSubcategoryPoints] = useState({}); // { subcategory_id: "0" | "-1" | ... }
    const [subcategoryFlags, setSubcategoryFlags] = useState({}); // { subcategory_id: "halal" | "not-halal" | "doubtful" }

    // Helper function to update question answer
    const handleQuestionAnswer = (questionId, answer) => {
        setQuestionAnswers(prev => ({
            ...prev,
            [questionId]: answer
        }));
    };

    // Helper function to update subcategory point
    const handleSubcategoryPoint = (subcategoryId, point) => {
        setSubcategoryPoints(prev => ({
            ...prev,
            [subcategoryId]: point
        }));
    };

    // Helper function to update subcategory flag
    const handleSubcategoryFlag = (subcategoryId, flag) => {
        setSubcategoryFlags(prev => ({
            ...prev,
            [subcategoryId]: flag
        }));
    };

    // Initialize state from responseReportJson when data loads
    useEffect(() => {
        if (responseReportJson && responseReportJson.categories) {
            // Initialize question answers
            const initialAnswers = {};
            const initialPoints = {};
            const initialFlags = {};

            responseReportJson.categories.forEach(category => {
                category.subcategories?.forEach(subcategory => {
                    // Initialize points and flags
                    initialPoints[subcategory.subcategory_id] = subcategory.point?.toString() ?? "0";
                    
                    // Convert flag number to string value
                    if (subcategory.flag === 1) {
                        initialFlags[subcategory.subcategory_id] = "halal";
                    } else if (subcategory.flag === 2) {
                        initialFlags[subcategory.subcategory_id] = "not-halal";
                    } else if (subcategory.flag === 3) {
                        initialFlags[subcategory.subcategory_id] = "doubtful";
                    }

                    // Initialize question answers
                    // answer: 1 = yes, 2 = no, 0 or null = not answered
                    subcategory.questions?.forEach(question => {
                        if (question.answer === 1) {
                            initialAnswers[question.question_id] = "yes";
                        } else if (question.answer === 2) {
                            initialAnswers[question.question_id] = "no";
                        }
                        // answer === 0 means not answered, so we don't set it (will be null/undefined)
                    });
                });
            });

            setQuestionAnswers(initialAnswers);
            setSubcategoryPoints(initialPoints);
            setSubcategoryFlags(initialFlags);
        }
    }, [responseReportJson]);

    // Calculate scores for subcategories and categories
    const calculatedScores = useMemo(() => {
        if (!responseReportJson || !responseReportJson.categories) {
            return { subcategoryScores: {}, categoryScores: {}, totalAverageScore: 0 };
        }

        const subcategoryScores = {};
        const categoryScores = {};

        // Flag reduction mapping: Off = 0%, halal = 20%, not-halal = 50%, doubtful = 100%
        const flagReductionMap = {
            "Off": 0,
            "halal": 0.2,
            "not-halal": 0.5,
            "doubtful": 1.0
        };

        responseReportJson.categories.forEach(category => {
            const subcategoryScoreArray = [];

            category.subcategories?.forEach(subcategory => {
                // Get current values (from state or default)
                const currentPoint = subcategoryPoints[subcategory.subcategory_id] ?? 
                                    subcategory.point?.toString() ?? "0";
                const currentFlag = subcategoryFlags[subcategory.subcategory_id] ?? 
                                   (subcategory.flag === 0 ? null : 
                                    subcategory.flag === 1 ? "halal" : 
                                    subcategory.flag === 2 ? "not-halal" : 
                                    subcategory.flag === 3 ? "doubtful" : null);

                // Count "Yes" answers in questions
                let yesCount = 0;
                const totalQuestions = subcategory.questions?.length || 0;

                if (subcategory.questions && totalQuestions > 0) {
                    subcategory.questions.forEach(question => {
                        const answer = questionAnswers[question.question_id] ?? 
                                      (question.answer === 1 ? "yes" : question.answer === 2 ? "no" : null);
                        if (answer === "yes") {
                            yesCount++;
                        }
                    });
                }

                // Convert numberOptions value to number (e.g., "0", "-1", "-2" -> 0, -1, -2)
                const numberOptionsValue = parseInt(currentPoint, 10) || 0;

                // Calculate base score: (yesCount + numberOptionsValue) * (100 / totalQuestions)
                const baseScore = totalQuestions > 0 
                    ? (yesCount + numberOptionsValue) * (100 / totalQuestions)
                    : 0;

                // Get reduction factor from flagOptions
                const reductionFactor = currentFlag ? (flagReductionMap[currentFlag] ?? 0) : 0;
                const multiplier = 1 - reductionFactor;

                // Apply reduction factor and ensure score >= 0
                const finalScore = Math.max(0, baseScore * multiplier);

                // Round to 2 decimal places
                subcategoryScores[subcategory.subcategory_id] = Math.round(finalScore * 100) / 100;
                subcategoryScoreArray.push(Math.round(finalScore * 100) / 100);
            });

            // Calculate category score as average of subcategory scores
            if (subcategoryScoreArray.length > 0) {
                const categoryAverage = subcategoryScoreArray.reduce((sum, score) => sum + score, 0) / subcategoryScoreArray.length;
                categoryScores[category.category_id] = Math.round(categoryAverage * 100) / 100;
            } else {
                categoryScores[category.category_id] = 0;
            }
        });

        // Calculate total average score (average of all category scores)
        const categoryScoreValues = Object.values(categoryScores);
        const totalAverageScore = categoryScoreValues.length > 0
            ? Math.round((categoryScoreValues.reduce((sum, score) => sum + score, 0) / categoryScoreValues.length) * 100) / 100
            : 0;

        return { subcategoryScores, categoryScores, totalAverageScore };
    }, [responseReportJson, questionAnswers, subcategoryPoints, subcategoryFlags]);

    // STATIC COMMENT MODAL
    const handleOpenCommentModal = () => setOpen(true);
    const handleCloseCommentModal = () => setOpen(false);

    const [open2, setOpen2] = useState(false);
    const handleOpenCommentDualModal = () => setOpen2(true);
    const handleCloseCommentDualModal = () => setOpen2(false);

    // HIDE UNHIDE TOGGLE
    const [isHidden, setIsHidden] = useState(false);

    const handleToggleShowHide = () => {
        setIsHidden(!isHidden);
    };


    // TEXT CONVERT TO LINK
    const [content, setContent] = useState(
        "Their consistent involvement in community events has made a real difference. It's great to see a company that genuinely cares about local impact."
    );

    const [showLinkInput, setShowLinkInput] = useState(false);
    const [linkUrl, setLinkUrl] = useState("");
    const [linkText, setLinkText] = useState("");
    const [selection, setSelection] = useState(null);

    const contentRef = useRef(null);
    const popoverRef = useRef(null);
    const linkInputRef = useRef(null); // <-- new ref for the input

    // Handle text selection
    const handleSelection = () => {
        const selectionObj = window.getSelection();
        if (selectionObj.toString().length > 0) {
            setSelection(selectionObj.getRangeAt(0));
            setLinkText(selectionObj.toString());
            setShowLinkInput(true);

            // Focus the input when popover opens via selection
            setTimeout(() => {
                linkInputRef.current?.focus();
            }, 0);
        } else {
            setShowLinkInput(false);
        }
    };

    // Apply link to selected text
    const applyLink = () => {
        if (selection && linkUrl) {
            const a = document.createElement("a");
            a.href = linkUrl;
            a.innerText = linkText || linkUrl;
            a.target = "_blank";

            selection.deleteContents();
            selection.insertNode(a);

            setShowLinkInput(false);
            setLinkUrl("");
            setLinkText("");
        }
    };

    // Close popover when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                showLinkInput &&
                contentRef.current &&
                popoverRef.current &&
                !contentRef.current.contains(e.target) &&
                !popoverRef.current.contains(e.target)
            ) {
                setShowLinkInput(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showLinkInput]);

    // Open popover on Ctrl + K / Cmd + K
    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
                e.preventDefault();

                // Get current selection
                const selectionObj = window.getSelection();
                if (selectionObj.toString().length > 0) {
                    setSelection(selectionObj.getRangeAt(0));
                    setLinkText(selectionObj.toString());
                } else {
                    setSelection(null);
                    setLinkText("");
                }

                setShowLinkInput(true);

                // Focus the input using its ref
                setTimeout(() => {
                    linkInputRef.current?.focus();
                }, 0);
            }

            // Close popover on Escape
            if (e.key === "Escape") {
                setShowLinkInput(false);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);


    // MODAL HEADER SCROLL ADD REMOVE CLASS
    const [scrolled, setScrolled] = useState(false);
    const bodyRef = useRef(null);

    const handleScroll = () => {
        if (bodyRef.current.scrollTop > 0) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    return (
        <>
            <LoaderFull isLoader={isLoader} />

                {renderMessage()}
                <div className="Screening_sidebar">
                <Sidebar />
                <ChakraProvider resetCSS={false}></ChakraProvider>
            </div>
            <div id="header_screening">
                <div className="logo">
                    <div className="logo_icon">
                        <img src={Logo} />
                    </div>
                </div>

                <div className="header_right_section">
                    <div className="header_section_top">
                        <div className="brand_name">
                            {responseDecodeData.company_name} <span>{responseDecodeData.company_symbol}</span>
                        </div>

                        <ul className="esg_top_head_right">
                            <li className="active">Industry</li>
                            <li>{responseDecodeData.industry}</li>
                        </ul>
                    </div>

                    <div className="header_section_bottom">
                        <div className="header_control_links">
                            <TimerProvider>
                                <Timer
                                    ref={timerRef}
                                    initialHours={hours1}
                                    initialMinutes={minutes1}
                                    initialSeconds={seconds1}
                                />
                            </TimerProvider>

                            <div className="lisk_dropdown_row">
                                <a href="#" className="link_trigger" onClick={toggleMenu}>
                                    <i className="icon-link"></i>
                                </a>

                                <div ref={popupRef} className={`paste_link_box ${isActive ? "active" : ""}`}>
                                    <div className="paste_link_header" style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center', padding: '8px 20px' }}>
                                        <span>Paste Links</span>
                                        {/* <Button className="btn_addmore_link">Add More Link</Button> */}
                                    </div>
                                    <div className="paste_link_body">
                                        <div className="link_field_row">
                                            <label>
                                                <i className="icon-link"></i>Link
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="https://"
                                                onChange={handleReportLRInputChange}
                                                value={reportLRUrl}
                                            />
                                        </div>

                                        <div className="link_field_row">
                                            <label>
                                                <i className="icon-link"></i>AR
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="https://"
                                                onChange={handleReportARInputChange}
                                                value={reportARUrl}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={tooltip} >
                                <button
                                    className="btn_slide_trigger"
                                    onClick={toggleBoxes}
                                    id="toggleBtn"
                                    ref={swapSwitchThRef}
                                >
                                    <img src={IconSlide} />
                                </button>
                            </Whisper>


                            <Tabs activeKey={activeKey} onSelect={handleTabChange} appearance="subtle" className="clsTab" >
                                <Tabs.Tab eventKey="1" title="LR"></Tabs.Tab>
                                <Tabs.Tab eventKey="2" title="AR"></Tabs.Tab>
                            </Tabs>


                            <button className="btn__upload__local__file" data-bs-toggle="modal" onClick={handleUploadClick}>
                                Upload Documents
                            </button>
                        </div>
                    </div>
                </div>
            </div >

            <div className="container-fluid content">
                <div className="btn__hide__show__report__row">
                    <button className="btn_hide_unhide_toggle" onClick={handleToggleShowHide}>
                        {isHidden ? "Unhide Report" : "Hide Report"}{" "}
                        <img src={isHidden ? iconUnhideReport : iconHideReport} alt="icon" />
                    </button>
                </div>
                <div className="report_table_data_row iri_screening_report_row misri_screening_report_row">
                    {!isHidden &&
                        <div id="Reportbox1" className={isBox1Visible ? "screening_report_pdf" : "slide-in"} >
                            <div className="tab-content">
                                {activeKey === "" ? (
                                    <div className="zero_data_content">
                                        <div className="zero_data_inner">
                                            <div className="report_load_desc">Choose the Type to load the latest Report <br />
                                                of {responseDecodeData.company_symbol} from Edgar</div>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 20, marginTop: 40 }}>
                                                <button className="btn_report_load" onClick={handle10kReport}>10-K</button>
                                                <button className="btn_report_load" onClick={handle10QReport}>10-Q</button>
                                            </div>

                                        </div>
                                    </div>
                                ) : activeKey === "1" ? (
                                    loadingLR ? (
                                        <div>Loading LR Report...</div>
                                    ) : reportLRUrl ? (
                                        <iframe
                                            title="LR Report PDF"
                                            width="100%"
                                            height="550"
                                            src={isValidURL(reportLRUrl) ? reportLRUrl : undefined}
                                            className="iframe_pdf"
                                        ></iframe>
                                    ) : (
                                        <div className="zero_data_content">
                                            <div className="zero_data_inner">
                                                <img src={IconNoData} alt="No Data" />
                                                <p>No LR Report Available</p>
                                            </div>
                                        </div>
                                    )
                                ) : activeKey === "2" ? (
                                    loadingAR ? (
                                        <div>Loading AR Report...</div>
                                    ) : reportARUrl ? (
                                        <iframe
                                            title="AR Report PDF"
                                            width="100%"
                                            height="550"
                                            src={isValidURL(reportARUrl) ? reportARUrl : undefined}
                                            className="iframe_pdf"
                                        ></iframe>
                                    ) : (
                                        <div className="zero_data_content">
                                            <div className="zero_data_inner">
                                                <img src={IconNoData} alt="No Data" />
                                                <p>No AR Report Available</p>
                                            </div>
                                        </div>
                                    )
                                ) : null}
                            </div>
                        </div>
                    }

                    <div id="Reportbox2" className={!isBox1Visible ? "slide-out" : "financial_table_col"} style={{ width: isHidden ? "100%" : "", }} >
                        <div className="financial_table esg__report__table_section">
                            {/* ref={scrollbarRef} */}
                            <div className="table-responsive" id="ReportScreening" style={{ height: 'auto' }}>
                                <table className="table esg__report__table misri_report_table">
                                    <tbody>
                                        {/* Total MISRI Score Row */}
                                        <tr className="total_misri_score">
                                            <th colSpan={2} style={{ textAlign: 'left', paddingRight: 0 }} onClick={handleOpenCommentDualModal}>Total MISRI Score</th>
                                            <th className="text-center total_MISRI_Score_value" style={{ width: 124, }}>
                                                {calculatedScores.totalAverageScore ?? 0}
                                            </th>
                                            <th className="text-center" style={{ width: 134 }}>
                                                {responseDecodeData?.score_classification || "Excellent"}
                                            </th>
                                        </tr>

                                        {/* Category Start */}
                                        {responseReportJson?.categories && responseReportJson.categories.map((category, categoryIndex) => {
                                            const categoryKey = `${category.category_id}`;
                                            
                                            // Determine header class based on category index (alternating styles)
                                            const categoryHeaderClass = categoryIndex === 0 ? "community_IR_header" : 
                                                                        categoryIndex === 1 ? "misri_not_halal_header" :
                                                                        categoryIndex === 2 ? "misri_lblue_header" :
                                                                        categoryIndex === 3 ? "misri_green_header" :
                                                                        "community_IR_header";

                                            return (
                                                <React.Fragment key={category.category_id}>
                                                    {/* Category Header Row */}
                                                    <tr className="community_IR_header">
                                                        <th style={{ textAlign: 'left', width: 25, paddingRight: 0 }}>
                                                            <button 
                                                                className="btn_accordion__toggle" 
                                                                onClick={() => toggleAccordion(category.category_id)} 
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <i className={`icon-${openRow === category.category_id ? "minus" : "plus"}`}></i>
                                                            </button>
                                                        </th>
                                                        <th style={{ textAlign: 'left' }}>{category.category_name}</th>
                                                        <th style={{ textAlign: 'center', width: 124, verticalAlign: 'middle', fontSize: 20, }}>
                                                            {calculatedScores.categoryScores[category.category_id] ?? 0}
                                                        </th>
                                                        <th style={{ textAlign: 'center', width: 134 }}>&nbsp;</th>
                                                    </tr>

                                                    {/* Category Subcategories */}
                                                    <tr className={`hidden_row ${openRow === category.category_id ? "is-open" : ""}`}>
                                                        <td colSpan={4} className="nested_table_cell" style={{ padding: 0 }}>
                                                            <table className="table">
                                                                <tbody>
                                                                    {/* Subcategory Start */}
                                                                    {category.subcategories && category.subcategories.map((subcategory, subcategoryIndex) => {
                                                                        const subcategoryKey = `${category.category_id}-${subcategory.subcategory_id}`;
                                                                        const currentPoint = subcategoryPoints[subcategory.subcategory_id] ?? subcategory.point?.toString() ?? "0";
                                                                        const currentFlag = subcategoryFlags[subcategory.subcategory_id] ?? 
                                                                                            (subcategory.flag === 0 ? null : 
                                                                                             subcategory.flag === 1 ? "halal" : 
                                                                                             subcategory.flag === 2 ? "not-halal" : 
                                                                                             subcategory.flag === 3 ? "doubtful" : null);

                                                                        // Determine subcategory header class based on subcategory index
                                                                        const subcategoryHeaderClass = subcategoryIndex % 2 === 0 ? "misri_not_halal_header" : "misri_lblue_header";

                                                                        return (
                                                                            <React.Fragment key={subcategory.subcategory_id}>
                                                                                {/* Subcategory Header Row */}
                                                                                {/* className={subcategoryHeaderClass} */}
                                                                                <tr >
                                                                                    <th style={{ textAlign: 'left', width: 25, paddingRight: 0 }}>
                                                                                        <button
                                                                                            className="btn_accordion__toggle"
                                                                                            onClick={() => toggleChild(subcategoryKey)}
                                                                                            style={{ cursor: "pointer" }}
                                                                                        >
                                                                                            <i className={`icon-${openChild === subcategoryKey ? "minus" : "plus"}`}></i>
                                                                                        </button>
                                                                                    </th>
                                                                                    <th style={{ textAlign: 'left' }}>
                                                                                        <div className="parent_row_quiz">
                                                                                            <button 
                                                                                                className="btn__misri_comment"
                                                                                                onClick={handleOpenCommentModal}
                                                                                            >
                                                                                                <i className="icon-comment"></i>
                                                                                            </button>
                                                                                            <span>{subcategory.subcategory_name}</span>
                                                                                        </div>
                                                                                    </th>
                                                                                    <th style={{ textAlign: 'center', width: 124, verticalAlign: 'middle' }}>
                                                                                        {calculatedScores.subcategoryScores[subcategory.subcategory_id] ?? 0}
                                                                                    </th>
                                                                                    <th style={{ textAlign: 'center', width: 118, verticalAlign: 'middle' }}>
                                                                                        <div className="select_dropdown_row">
                                                                                            <CustomDropdown
                                                                                                options={numberOptions}
                                                                                                value={currentPoint}
                                                                                                setValue={(value) => handleSubcategoryPoint(subcategory.subcategory_id, value)}
                                                                                                placeholder="0"
                                                                                                customArrow={<img src={iconCaustomCaretArrow} alt="caret" />}
                                                                                            />
                                                                                            <CustomDropdown
                                                                                                options={flagOptions}
                                                                                                value={currentFlag}
                                                                                                setValue={(value) => handleSubcategoryFlag(subcategory.subcategory_id, value)}
                                                                                                placeholder="Off"
                                                                                                customArrow={<img src={iconCaustomCaretArrow} alt="caret" />}
                                                                                            />
                                                                                        </div>
                                                                                    </th>
                                                                                </tr>

                                                                                {/* Questions Start */}
                                                                                <tr className={`hidden_row ${openChild === subcategoryKey ? "is-open" : ""}`}>
                                                                                    <td colSpan={4} className="nested_table_cell" style={{ padding: 0 }}>
                                                                                        <table className="table quiz__table">
                                                                                            <tbody>
                                                                                                {subcategory.questions && subcategory.questions.map((question, questionIndex) => {
                                                                                                    const currentAnswer = questionAnswers[question.question_id] ?? 
                                                                                                                          (question.answer === 1 ? "yes" : question.answer === 2 ? "no" : null);

                                                                                                    return (
                                                                                                        <tr key={question.question_id}>
                                                                                                            <td className="spacer-cell">&nbsp;</td>
                                                                                                            <td>
                                                                                                                <div className="parent_row_quiz">
                                                                                                                    <button className="btn__misri_comment">
                                                                                                                        <i className="icon-comment"></i>
                                                                                                                    </button>
                                                                                                                    <strong>Q{questionIndex + 1}.</strong>
                                                                                                                    <p>{question.text}</p>
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            <td className="text-center" style={{ width: 140 }}>
                                                                                                                <div className="toggle__container">
                                                                                                                    <button
                                                                                                                        className={`toggle__btn yes ${currentAnswer === "yes" ? "active" : ""}`}
                                                                                                                        onClick={() => handleQuestionAnswer(question.question_id, "yes")}
                                                                                                                    >
                                                                                                                        Yes
                                                                                                                    </button>
                                                                                                                    <button
                                                                                                                        className={`toggle__btn no ${currentAnswer === "no" ? "active" : ""}`}
                                                                                                                        onClick={() => handleQuestionAnswer(question.question_id, "no")}
                                                                                                                    >
                                                                                                                        No
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            <td style={{ width: 118 }}>&nbsp;</td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                })}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                                {/* Questions End */}
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                                    {/* Subcategory End */}
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })}
                                        {/* Category End */}
                                    </tbody>
                                </table>
                            </div>


                        </div>
                    </div>

                </div>

                <div className={!isBox1Visible ? "add_new_btn_group clsScreeningButton esg__report__table_section_wrap slide-out" : "add_new_btn_group clsScreeningButton esg__report__table_section_wrap misri__report__table_section_wrap"}
                    style={{ width: isHidden ? "100%" : "", }}>
                    {(roleName === "MERLIN_ADMIN" || roleName === "MERLIN_SENIOR_ANALYST") && responseDecodeData.status == 2 ? (
                        <>
                            {/*  */}

                            <button className="btn_review_subticker" onClick={handleBack}> Back </button>
                            <button className="btn_cancel_form" data-bs-toggle="modal" data-bs-target="#ModalPublishReport" onClick={handleResetSequence}>
                                Publish
                            </button>
                            <button className="btn_cancel_form" onClick={handleSave}>
                                Save
                            </button>
                            <button className="btn_save_form" onClick={handleReject}>
                                Reject
                            </button>
                        </>
                    ) : (roleName === "MERLIN_ADMIN" || roleName === "MERLIN_SENIOR_ANALYST") && responseDecodeData.status == 3 ? (
                        <button className="btn_cancel_form" data-bs-toggle="modal" data-bs-target="#ModalUnPublishReport">
                            Unpublish
                        </button>
                    ) : (
                        <>
                            <button className="btn_cancel_form" onClick={handleBack}> Back </button>
                            <button className="btn_save_form" onClick={handleSendToReview} > Send to review </button>
                            <button className="btn_review_subticker" onClick={handleSaveAsDraft}> Save as draft </button>
                        </>
                    )}


                </div>
            </div>

            <div class="modal fade report_delete_modals" id="ModalPublishReport" tabindex="-1" aria-labelledby="AddNewAnalystModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <h5>Are you sure you want to publish this report?</h5>
                            <p>Once published, it cannot be edited</p>
                            <div class="btn__group mt-5" style={{}}>
                                <button type="button" class="btn_cancel" id="CancelPublish" data-bs-dismiss="modal">Cancel</button>
                                {/* <button type="button" class="btn_delete" onClick={handlePublish}>Publish</button>   */}
                                <Button className="btn_delete" onClick={handlePublish} loading={publishButtonLoader}>Publish</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade report_delete_modals" id="ModalUnPublishReport" tabindex="-1" aria-labelledby="AddNewAnalystModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <h5>Are you sure you want to Unpublish this report?</h5>
                            <p>Once unpublished, it goes to Review section</p>
                            <div class="btn__group mt-5" style={{}}>
                                <button type="button" class="btn_cancel" id="CancelUnPublish" data-bs-dismiss="modal">Cancel</button>
                                <Button className="btn_delete" onClick={handleUnPublish} loading={unpublishButtonLoader}>Unpublish</Button>

                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* <Button onClick={handleOpen3}> Open</Button> */}

            <Modal ref={bodyRef} onScroll={handleScroll} open={open} onClose={handleCloseCommentModal} className={isBox1Visible ? "comment_modal_body comment_modal_body_iri comment_modal_body_misri" : "comment_modal_body comment_modal_body_iri comment_modal_body_misri slide-in"}>
                {renderMessage1()}
                {commentLoading ? (

                    <div style={{ backgroundColor: "white", height: "100vh" }}>
                        <Placeholder.Paragraph rows={8} />
                        <Loader center content={commentLoading} />
                    </div>
                ) : (
                    <>
                        <Modal.Header className={`comment_modal_header ${scrolled ? "scrolled" : ""}`}>
                            <Modal.Title className="comment_modal_title">Add Comment</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div className="comment_modal_content">
                                <h4 className="mb-3">Comments({commentCount}{ })</h4>
                                {commentdata && commentdata.length === 0 ? (
                                    <div className="zero_comment">
                                        <img src={IconNoComment} />
                                        <p>No Comments yet</p>
                                    </div>
                                ) : (
                                    commentdata &&
                                    commentdata.map((item, index) => (
                                        <div className="comment_modal_box">
                                            <div className="flex_sp_row comment_modal_box_top">
                                                <h5>By {item.username}</h5>
                                                <div className="comment_date">{item.time_description}</div>

                                            </div>

                                            <p dangerouslySetInnerHTML={{ __html: item.messages }}></p>
                                            {/* <p dangerouslySetInnerHTML={{ __html: item.messages }}></p> */}

                                            <ul className="source__list">
                                                <li><span>{item.source}</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>

                                                </li>
                                            </ul>

                                            {/* <div className="flex_sp_row comment_modal_box_bottom">
                                                <h6>Source : {item.source} </h6>
                                                <a href="javascript:void(0);" className="cdelete_icon" onClick={() => deleteComment(item.id)}><i className="icon-delete"></i></a>

                                            </div> */}
                                            <div className="flex_sp_row comment_modal_box_bottom">
                                                <button className="btn_report_download">
                                                    <img src={IconBtnPDF} />
                                                    <span>Apple_Report</span>
                                                    <i className="icon-download"></i>
                                                </button>
                                                <a
                                                    href="javascript:void(0);"
                                                    className="cdelete_icon"
                                                    onClick={() => deleteComment(item.id)}
                                                >
                                                    <i className="icon-delete"></i>
                                                </a>
                                            </div>
                                            <>
                                                {item.file_type !== null && (
                                                    <div style={{ marginTop: 10 }}>
                                                        <button className="btn__file__download" key={index} onClick={() => {
                                                            const link = document.createElement('a');
                                                            link.href = item.file;
                                                            link.setAttribute('download', ''); // Force download
                                                            link.setAttribute('target', '_blank'); // Optional
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        }}>
                                                            <img src={item.file_type?.toLowerCase() === 'pdf' ? IconPDFFile : item.file_type?.toLowerCase() === 'xlsx' ? Icons_excel : ['jpg', 'jpeg', 'png'].includes(item.file_type?.toLowerCase()) ? icon_jpeg_png : ['doc', 'docx'].includes(item.file_type?.toLowerCase()) ? icons_Docs : null} /> <span>{item.file_name}</span>
                                                            <img src={IconDownloadFile} /> </button>
                                                    </div>
                                                )}
                                            </>


                                        </div>
                                    ))
                                )}
                            </div>


                        </Modal.Body>
                        <Modal.Footer className="modal_footer_comment_form">
                            <div className="modal_footer_comment_inner">
                                <div className='mt-3'>
                                    <label className='label_form'>Comment</label>
                                    {/* <input type='text' className='form-control' placeholder='Enter your comment' id="txtComment" /> */}
                                    <textarea className='form__control textarea_resisable' rows={4} style={{ height: 'auto' }} placeholder='Enter your comment' id="txtComment"></textarea>
                                </div>
                                <div className='mt-3'>
                                    <label className='label_form'>Source</label>
                                    <div className="input__group__form">
                                        <input type='text' className='form-control' placeholder='Add source' id="txtSource" />
                                        <button className="btn__add_plus">Add</button>
                                    </div>
                                </div>

                                <ul className="source__list">
                                    <li><span>Source 1</span>
                                        <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                            <div className="custom_tooltip_box_row">
                                                <div className="custom_tooltip_box_inner">
                                                    <div className="link__icon"><i className="icon-link"></i></div>
                                                    <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                    <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                    <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                </div>
                                            </div>
                                        </Tooltip>}>
                                            <div className="icon__source"><img src={IconInfoNew} /></div>
                                        </Whisper>
                                    </li>

                                    <li><span>Source 2</span>
                                        <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                            <div className="custom_tooltip_box_row">
                                                <div className="custom_tooltip_box_inner">
                                                    <div className="link__icon"><i className="icon-link"></i></div>
                                                    <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                    <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                    <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                </div>
                                            </div>
                                        </Tooltip>}>
                                            <div className="icon__source"><img src={IconInfoNew} /></div>
                                        </Whisper>
                                    </li>

                                    <li><span>Source 3</span>
                                        <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                            <div className="custom_tooltip_box_row">
                                                <div className="custom_tooltip_box_inner">
                                                    <div className="link__icon"><i className="icon-link"></i></div>
                                                    <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                    <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                    <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                </div>
                                            </div>
                                        </Tooltip>}>
                                            <div className="icon__source"><img src={IconInfoNew} /></div>
                                        </Whisper>
                                    </li>

                                    <li><span>Source 4</span>
                                        <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                            <div className="custom_tooltip_box_row">
                                                <div className="custom_tooltip_box_inner">
                                                    <div className="link__icon"><i className="icon-link"></i></div>
                                                    <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                    <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                    <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                </div>
                                            </div>
                                        </Tooltip>}>
                                            <div className="icon__source"><img src={IconInfoNew} /></div>
                                        </Whisper>
                                    </li>

                                    <li><span>Source 5</span>
                                        <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                            <div className="custom_tooltip_box_row">
                                                <div className="custom_tooltip_box_inner">
                                                    <div className="link__icon"><i className="icon-link"></i></div>
                                                    <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                    <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                    <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                </div>
                                            </div>
                                        </Tooltip>}>
                                            <div className="icon__source"><img src={IconInfoNew} /></div>
                                        </Whisper>
                                    </li>
                                </ul>

                                <div className='mt-3'>
                                    <label className='label_form'>Attach File</label>
                                    <input type='file' className='form-control' id="txtFile" />
                                </div>

                                <div className="btn__group">
                                    <button type="button" className="btn_cancel" onClick={handleCommentBoxClose}>Cancel</button>
                                    <Button className="btn_comment" onClick={() => addComment()} loading={addCommentLoader}>Add Comment</Button>
                                </div>

                            </div>
                        </Modal.Footer>


                    </>
                )}
            </Modal>

            {/* MODAL DUAL */}
            <Modal open={open2} onClose={handleCloseCommentDualModal} className="comment_modal_dual">

                {/* <div style={{ backgroundColor: "white", height: "100vh" }}>
                        <Placeholder.Paragraph rows={8} />
                        <Loader center content={commentLoading} />
                    </div> */}

                <>
                    <Modal.Header className="comment_modal_header">
                        <Modal.Title className="comment_modal_title">Social Investment & Alignment with Social Upliftment</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="comment_modal_dual_row">
                            <div className="comment_modal_dual_col_left">
                                <div className="comment_modal_dual_col_left_inner">
                                    <div className="comment_modal_dual_quiz_section">
                                        <h5>Question 1</h5>
                                        <div className="comment_modal_dual_quiz_row">
                                            <div className="comment_section_title_with_update">
                                                <h6>By Babuddin Ahmed</h6>
                                                <span>Just Now</span>
                                            </div>
                                            <p>Their consistent involvement in community events has made a real difference. It's great to see a company that genuinely cares about local impact.</p>
                                            <ul className="source__list">
                                                <li><span>Source 1</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                                <li><span>Source 2</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="comment_modal_dual_quiz_row">
                                            <div className="comment_section_title_with_update">
                                                <h6>By Lorem Ipsum</h6>
                                                <span>1 day ago</span>
                                            </div>
                                            <p>Their consistent involvement in community events has made a real difference. It's great to see a company that genuinely cares about local impact.</p>
                                            <ul className="source__list">
                                                <li><span>Source 1</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                                <li><span>Source 2</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                                <li><span>Source 3</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="comment_modal_dual_quiz_section">
                                        <h5>Question 2</h5>
                                        <div className="comment_modal_dual_quiz_row">
                                            <div className="comment_section_title_with_update">
                                                <h6>By Lorem Ipsum</h6>
                                                <span>1 week ago</span>
                                            </div>
                                            <p>Their consistent involvement in community events has made a real difference. It's great to see a company that genuinely cares about local impact.</p>
                                            <ul className="source__list">
                                                <li><span>Source 1</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                                <li><span>Source 2</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="comment_modal_dual_quiz_row">
                                            <div className="comment_section_title_with_update">
                                                <h6>By Lorem Ipsum</h6>
                                                <span>1 week ago</span>
                                            </div>
                                            <p>Their consistent involvement in community events has made a real difference. It's great to see a company that genuinely cares about local impact.</p>
                                            <ul className="source__list">
                                                <li><span>Source 1</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                                <li><span>Source 2</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                                <li><span>Source 3</span>
                                                    <Whisper placement="bottom" controlId="control-id-hover" trigger="click" speaker={<Tooltip className="custom_tooltip_wrapper">
                                                        <div className="custom_tooltip_box_row">
                                                            <div className="custom_tooltip_box_inner">
                                                                <div className="link__icon"><i className="icon-link"></i></div>
                                                                <a href="#" target="_blank" className="source__link__text">https://www.figma.com/design/IlNTLDW1fGT5p7FbCRQTa8/Nova?node-id=4672-42377&t=Iht8awHTId7aGfer-1</a>
                                                                <button className="btn__edit_link"><i className="fa fa-pencil"></i></button>
                                                                <button className="btn__remove_link"><i className="icon-delete"></i></button>
                                                            </div>
                                                        </div>
                                                    </Tooltip>}>
                                                        <div className="icon__source"><img src={IconInfoNew} /></div>
                                                    </Whisper>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="comment_modal_dual_col_right">
                                <div className="comment_modal_dual_col_right_inner">
                                    <h5>Comments(2)</h5>
                                    <div className="add_comments_section">
                                        <div className="comment_section_title_with_update">
                                            <h6>By Babuddin Ahmed</h6>
                                            <div className="update_with_delete">
                                                <span>Just Now</span>
                                                <a
                                                    href="javascript:void(0);"
                                                    className="cdelete_icon"
                                                >
                                                    <i className="icon-delete"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="add_comments_row">
                                            <p>Their consistent involvement in community events has made a real difference. It s great to see a company that genuinely cares about local impact. community events has made a real difference. It s great to see a company that genuinely cares about local <a href="#">https://www.flaticon.com/</a></p>
                                            <button className="btn_report_download">
                                                <img src={IconBtnPDF} />
                                                <span>Apple_Report</span>
                                                <i className="icon-download"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="add_comments_section">
                                        <div className="comment_section_title_with_update">
                                            <h6>By Babuddin Ahmed</h6>
                                            <div className="update_with_delete">
                                                <span>Just Now</span>
                                                <a
                                                    href="javascript:void(0);"
                                                    className="cdelete_icon"
                                                >
                                                    <i className="icon-delete"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="add_comments_row">
                                            <p>Their consistent involvement in community events has made a real difference. It's great to see a company that genuinely cares about local impact.</p>
                                        </div>
                                    </div>

                                    <div className="add_comments_section">
                                        <div className="comment_section_title_with_update">
                                            <h6>By Babuddin Ahmed</h6>
                                            <div className="update_with_delete">
                                                <span>Just Now</span>
                                                <a
                                                    href="javascript:void(0);"
                                                    className="cdelete_icon"
                                                >
                                                    <i className="icon-delete"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="add_comments_row">
                                            <p>Their consistent involvement in community events has made a real difference. It s great to see a company that genuinely cares about local impact. community events has made a real difference. It s great to see a company that genuinely cares about local <a href="#">https://www.flaticon.com/</a></p>
                                            <button className="btn_report_download">
                                                <img src={IconBtnPDF} />
                                                <span>Apple_Report</span>
                                                <i className="icon-download"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="add_comments_section">
                                        <div className="comment_section_title_with_update">
                                            <h6>By Babuddin Ahmed</h6>
                                            <div className="update_with_delete">
                                                <span>Just Now</span>
                                                <a
                                                    href="javascript:void(0);"
                                                    className="cdelete_icon"
                                                >
                                                    <i className="icon-delete"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="add_comments_row">
                                            <p>Their consistent involvement in community events has made a real difference. It's great to see a company that genuinely cares about local impact.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="comment_modal_dual_form_section">
                                    <div className="modal_footer_comment_inner">
                                        <div className='mt-3 label_with_text_link'>
                                            <label className='label_form'>Comment</label>
                                            <p><span>⌘</span> + <span>K</span> Links</p>
                                            {/* <input type='text' className='form-control' placeholder='Enter your comment' id="txtComment" /> */}
                                            {/* <textarea contentEditable onMouseUp={handleSelection} suppressContentEditableWarning className='form__control textarea_resisable' rows={4} style={{ height: 'auto' }} placeholder='Enter your comment' id="txtComment">{content}</textarea> */}
                                        </div>


                                        <Whisper
                                            trigger="none"
                                            open={showLinkInput}
                                            placement="top"
                                            ref={popoverRef}
                                            speaker={
                                                <Popover full className="popover_text_link">
                                                    <div className="tooltip_form_inner">
                                                        <div className="link_text_field">
                                                            <label>Paste link to search</label>
                                                            <input
                                                                type="text"
                                                                placeholder="https://"
                                                                className="form-control"
                                                                ref={linkInputRef}
                                                                value={linkUrl}
                                                                onChange={(e) => setLinkUrl(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="link_text_field mt-4">
                                                            <label>Display Text (optional)</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Enter Display Text"
                                                                value={linkText}
                                                                className="form-control"
                                                                onChange={(e) => setLinkText(e.target.value)}
                                                            />
                                                        </div>


                                                        <button
                                                            onClick={applyLink}
                                                            className="btn__save mt-4"
                                                            style={{ borderRadius: 5 }}
                                                        >
                                                            Add Link
                                                        </button>
                                                    </div>
                                                </Popover>
                                            }
                                            onClickOutside={() => setShowLinkInput(false)}
                                        >
                                            <div
                                                contentEditable
                                                suppressContentEditableWarning
                                                onMouseUp={handleSelection}
                                                ref={contentRef}
                                                className="form__control textarea_resisable"
                                                style={{
                                                    height: 'auto'
                                                }}
                                            >
                                                {content}
                                            </div>

                                        </Whisper>

                                        <div className="btn__group">
                                            <button type="button" className="btn_cancel" onClick={handleCommentBoxClose}>Cancel</button>
                                            <Button className="btn_comment" onClick={() => addComment()} loading={addCommentLoader}>Add Comment</Button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </>
            </Modal>

            <div className={`modal fade upload_file_modals ${showUploadManualModal ? "d-block show" : "d-none"}`} id="UploadFileModal" tabIndex="-1" aria-labelledby="UploadFileModalLabel" aria-hidden="true" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 760 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title fs-5">Upload Local Files</h4>
                            <p>Add your documents here, and you can upload up to 15 MB files max</p>
                        </div>
                        <div className="modal-body">
                            <div className="upload_section_main">
                                <Uploader
                                    action=""
                                    draggable
                                    multiple // Allow multiple files
                                    listType="text"
                                    accept=".jpg,.png,.pdf"
                                    onChange={(files) => files.forEach((file) => handleFileSelect(file))}
                                    //defaultFileList={fileList1}
                                    fileList={uploadedfileList}
                                    fileListVisible={false} // file list visible nahi hogi.
                                //onRemove={handleRemove}
                                >
                                    <div>
                                        <div className="upload_section">
                                            <img src={iconUpload} alt="Upload Icon" />
                                            <p>Drag your file(s) to start uploading</p>
                                            <div className="or__text"><span>OR</span></div>
                                            <span className="btn__browse__file">Browse files</span>
                                        </div>
                                        <h6 style={{ marginBottom: 10 }}>Only support .jpg, .png, .pdf and files</h6>
                                    </div>
                                </Uploader>



                                <div className="customUploadwrap">



                                    {uploadedfileList.length === 0 ? (
                                        <h5 style={{ fontSize: 14, fontWeight: 600 }}>No files available</h5>
                                    ) : (
                                        <>
                                            <h5 style={{ fontSize: 14, fontWeight: 600 }}>Uploaded Documents</h5>
                                            {uploadedfileList.map((file) => {
                                                const percent = progress[file.name] || 101;
                                                const elapsedTime = (Date.now() - file.startTime) / 1000; // in seconds
                                                const estimatedTimeRemaining =
                                                    percent > 0 ? Math.max(((100 - percent) * elapsedTime) / percent, 1) : 0;

                                                return (
                                                    <div key={file.id} className="customUploadList">
                                                        {percent < 100 ? (
                                                            // **Uploading Section**
                                                            <div>
                                                                <div className="progress_row">
                                                                    <div className="progress_text">
                                                                        <h4>Uploading...</h4>
                                                                        <p>
                                                                            {percent}% <span> • {Math.round(estimatedTimeRemaining)} seconds remaining</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <Progress.Line percent={percent} showInfo={false} strokeColor="#2B3779" />
                                                            </div>
                                                        ) : (
                                                            // **Uploaded Section**
                                                            <div className="customUploadProgress_row">
                                                                <div className="filename_row">
                                                                    <div className="class_icon" style={{ cursor: 'pointer' }}>
                                                                        {/* <Link  to={file.type === "pdf" ? `https://docs.google.com/viewer?url=${encodeURIComponent(file.url)}` : file.url} target="_blank" rel="noopener noreferrer"> */}
                                                                        <img src={file.type == "pdf" ? iconPDF : file.type == "png" ? iconPNG : iconJPG} onClick={() => handlePreviewClick(file)} />
                                                                        {/* </Link> */}
                                                                    </div>
                                                                    <div className="class_filename">
                                                                        <h5>{file.name}</h5>
                                                                        <span className="file_size">{file.size} -{file.id}</span>
                                                                    </div>
                                                                </div>
                                                                <button className="cls_btn_cross" onClick={() => handleRemove(file)}>
                                                                    <img src={iconCancel} />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>

                                                );
                                            })}
                                        </>
                                    )}

                                </div>





                            </div>

                            <div className="btn__group mt-5">
                                <button type="button" className="btn_cancel" onClick={closeUploadManualModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class={`modal fade upload_file_modal ${showUploadpreviewModal ? "d-block show" : "d-none"}`} id="ModalManualReport" tabindex="-1" aria-labelledby="AddNewAnalystModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" >
                    <div class="modal-content">
                        <button type="button" class="btn-close" aria-label="Close" onClick={closeUploadpreviewModal}></button>
                        <div class="modal-body">
                            {reportType === "pdf" ? (
                                <iframe
                                    title="LR Report PDF"
                                    width="100%"
                                    height="550"
                                    src={preview}
                                    className="iframe_pdf"
                                ></iframe>
                            ) : (
                                <div className="upload_img_modal">
                                    <img src={preview} alt="Preview" />
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default IRIReportContent;

